const data: any = {
  rt: {
    "b": {
      "thisOpponent": "αυτόν τον αντίπαλο",
      "firstMatch": "Πρώτος αγώνας",
      "lastMatch": "Τελευταίος αγώνας · {{value}}",
      "oneRated": "με {{name}} {{value}} · 1 αγώνας με βαθμολογία",
      "average": "με {{name}} {{value}} · {{count}} αγώνες",
      "oneRatedMe": "με εμένα {{value}} · 1 αγώνας με βαθμολογία",
      "averageMe": "με εμένα {{value}} · {{count}} αγώνες",
      "comparisonControls": "Ιστορικές συγκρίσεις",
      "showH2H": "Μέσοι όροι από τα μεταξύ σας παιχνίδια",
      "showOverall": "Γενικοί μέσοι όροι από όλους τους αγώνες"
    },
    "f": {
      "shot_accuracy": "Ακρίβεια χτυπημάτων",
      "call_accuracy": "Ακρίβεια στα calls (μέσα/έξω)",
      "confrontational_tendency": "Αντιπαραθετικότητα",
      "forehand": "Forehand",
      "backhand": "Backhand",
      "service": "Σερβίς",
      "return": "Επιστροφή σερβίς",
      "volley": "Βολέ",
      "smash": "Σμας",
      "drop_shot": "Ντροπ σοτ",
      "lob": "Λόμπα",
      "stamina": "Αντοχή",
      "speed": "Ταχύτητα",
      "court_coverage": "Κάλυψη γηπέδου",
      "tactics": "Τακτική",
      "awareness": "Αντίληψη γηπέδου",
      "shot_variety": "Ποικιλία χτυπημάτων",
      "winners": "Winners",
      "unforced_errors": "Αβίαστα λάθη",
      "fh_topspin": "Forehand τοπ σπιν",
      "fh_slice": "Forehand σλάις",
      "bh_topspin": "Backhand τοπ σπιν",
      "bh_slice": "Backhand σλάις",
      "first_serve": "1ο σερβίς",
      "first_serve_speed": "Ταχύτητα 1ου σερβίς",
      "second_serve": "2ο σερβίς",
      "second_serve_speed": "Ταχύτητα 2ου σερβίς",
      "serve_flat": "Επίπεδο σερβίς",
      "serve_kick": "Σερβίς κικ",
      "serve_slice": "Σερβίς σλάις",
      "first_serve_pct_est": "1α σερβίς μέσα (εκτίμηση)",
      "second_serve_pct_est": "2α σερβίς μέσα (εκτίμηση)",
      "passing_shots": "Passing shot",
      "volley_d": "Βολέ",
      "tactics_d": "Τακτική",
      "speed_d": "Ταχύτητα",
      "stamina_d": "Αντοχή",
      "composure": "Ψυχραιμία",
      "concentration": "Συγκέντρωση",
      "calmness": "Ηρεμία",
      "anxiety": "Άγχος",
      "confidence": "Αυτοπεποίθηση",
      "fighting_spirit": "Αγωνιστικότητα",
      "mental_resilience": "Ψυχική ανθεκτικότητα",
      "belief_pre": "Πίστη στη νίκη πριν τον αγώνα",
      "belief_in": "Πίστη στη νίκη κατά τη διάρκεια του αγώνα"
    },
    "g": {
      "movement": "Κίνηση & τοποθέτηση",
      "behaviour": "Συμπεριφορά",
      "forehand": "Forehand",
      "backhand": "Backhand",
      "serve": "Σερβίς",
      "rally": "Ράλλι κι επιστροφές",
      "net": "Παιχνίδι στο φιλέ",
      "physical": "Φυσική κατάσταση & τακτική"
    },
    "h": {
      "shot_accuracy": "Πόσο σταθερά πήγαιναν τα χτυπήματά σου εκεί που ήθελες;",
      "call_accuracy": "Πόσο ακριβείς θεωρείς ότι ήταν οι αποφάσεις σου για μέσα/έξω;",
      "confrontational_tendency": "Τάση για διαφωνίες, εντάσεις ή αντιπαραθέσεις με τον αντίπαλο."
    },
    "dist": {
      "winnersIncl": "Winners (μαζί με άσους)",
      "unforcedIncl": "Αβίαστα λάθη (μαζί με διπλά λάθη)",
      "assignTo": "Δώσε το υπόλοιπο {{n}}% σε…",
      "countHint": "Κατέγραψες {{a}} άσους και {{d}} διπλά λάθη.",
      "remainingInline": "Απομένει {{n}}%",
      "complete": "Ολοκληρώθηκε — 100% κατανεμημένο",
      "assignRemainder": "Ανάθεσε το υπόλοιπο {{n}}% εδώ",
      "tab": "Πόντοι",
      "title": "Πώς τελείωναν οι πόντοι;",
      "helper": "Δική σου εκτίμηση — δεν χρειάζεται καταγραφή πόντο-πόντο. Κατά προσέγγιση νούμερα αρκούν· μπορείς και να το παραλείψεις.",
      "winners": "Winners",
      "forced": "Εξαναγκασμένα λάθη",
      "unforced": "Αβίαστα λάθη",
      "df": "Διπλά λάθη",
      "total": "Σύνολο",
      "remaining": "{{n}}% δεν έχει κατανεμηθεί",
      "over": "{{n}}% πάνω από το 100",
      "myTeam": "Η ομάδα μου",
      "oppTeam": "Ομάδα αντιπάλων"
    }
  },
  onboarding: {
    eyebrow: "Ξεκίνα",
    valueHistory: "Χτίσε το πλήρες ιστορικό των αγώνων σου",
    valueStats: "Κατάλαβε τα στατιστικά σου",
    valueImprove: "Παρακολούθησε την πρόοδό σου με τον καιρό",
    showMore: "Πώς λειτουργεί & δυνατότητες",
    showLess: "Λιγότερα",
    headlineDashboard: "Το dashboard σου περιμένει τον πρώτο σου αγώνα",
    headlineMatches: "Κατέγραψε έναν αγώνα για να ξεκινήσει η ιστορία σου",
    headlineStats: "Τα στατιστικά ξεκλειδώνουν μετά τον πρώτο σου αγώνα",
    intro: "Το Tennis Log μετατρέπει κάθε αγώνα σε γνώση. Κατέγραψε τον πρώτο σου σε λιγότερο από ένα λεπτό και δες το dashboard, τα γραφήματα και τον AI προπονητή σου να ζωντανεύουν.",
    cta: "+ Κατέγραψε τον πρώτο αγώνα",
    howTitle: "Πώς λειτουργεί",
    s1Title: "Πρόσθεσε αγώνα",
    s1Desc: "Πάτα «Νέος αγώνας», συμπλήρωσε ημερομηνία, αντίπαλο, γήπεδο και σκορ. Τα drop-down κάνουν τη δουλειά γρήγορα.",
    s2Title: "Πρόσθεσε λεπτομέρεια (προαιρετικά)",
    s2Desc: "Ξεκίνησε με το Fast Track για να αποθηκεύσεις τα βασικά και, στη συνέχεια, πρόσθεσε όσες λεπτομέρειες θέλεις μέσω των Score Timeline, Opponent, Context, Performance Review και Smartwatch.",
    s3Title: "Δες τα στατιστικά σου",
    s3Desc: "Win rate, hold rate, breaks, σετ, games, επιφάνεια, γήπεδο, αντίπαλος — όλα ενημερώνονται άμεσα.",
    s4Title: "Πάρε AI insights",
    s4Desc: "Η ανάλυση AI είναι διαθέσιμη μόλις καταγράψεις δεδομένα αγώνα και γενικά γίνεται πιο ενημερωτική όσο μεγαλώνει το ιστορικό αγώνων σου.",
    benefitsTitle: "Τι θα βλέπεις όταν αρχίσεις",
    b1Title: "Ποσοστό νίκης",
    b1Desc: "Φιλτράρισε ανά έτος, μορφή (μονά/διπλά/μικτά) και είδος (φιλικό/επίσημο). Δες τάσεις ανά σεζόν.",
    b2Title: "Σετ, games, hold & break rate",
    b2Desc: "Πέρα από W/L: πόσο συχνά κρατάς το σερβίς, πόσο συχνά κάνεις break, διαφορά σετ και games.",
    b3Title: "Στατιστικά smartwatch",
    b3Desc: "Ανέβασε ένα screenshot από Mi Fitness, Garmin, Apple Watch ή Zepp — το AI γεμίζει θερμίδες, BPM και HR ζώνες.",
    b4Title: "Heatmap ανά game",
    b4Desc: "Δες εάν «κρεμάς» στο game 3 ή κλείνεις το 11 — ανά πλευρά σερβίς και σετ.",
    b5Title: "Αξιολογήσεις απόδοσης",
    b5Desc: "Βαθμολόγησε forehand, backhand, σερβίς, ριτόρν, βολέ, αντίληψη, κάλυψη γηπέδου. Όλα σε radar chart.",
    b6Title: "AI προπονητής",
    b6Desc: "Προσωπική αφήγηση δυνατών σημείων, αδυναμιών και μοτίβων — γραμμένη σαν προπονητής, βασισμένη στα δεδομένα σου.",
    tipsTitle: "Συμβουλές για την πρώτη καταχώριση",
    tip1: "Ξεκίνα απλά: ημερομηνία, αντίπαλος και σκορ είναι αρκετά.",
    tip2: "Πρόσθεσε γήπεδο και επιφάνεια — με τον καιρό θα δεις πού παίζεις καλύτερα.",
    tip3: "Δοκίμασε ένα game-by-game σετ για να ξεκλειδώσεις hold rate και heatmaps.",
    tip4: "Αξιολόγησε ειλικρινά τον εαυτό σου — λίγες καταχωρίσεις τροφοδοτούν τον AI.",
    tip5: "Έχεις παλιούς αγώνες; Πρόσθεσέ τους κι αυτούς. Η ιστορία φτιάχνει τα στατιστικά.",
  },
  nav: { dashboard: "Dashboard", matches: "Αγώνες", add: "Νέος αγώνας", stats: "Στατιστικά", insights: "AI Insights", logout: "Έξοδος" , settings: "Ρυθμίσεις", invite: "Προσκάλεσε φίλο" },
  brand: { name: "My Tennis Ledger", tagline: "Γίνε καλύτερος μελετώντας το ιστορικό σου" },
  auth: { age16: "Επιβεβαιώνω ότι είμαι τουλάχιστον 16 ετών. Οι λογαριασμοί Tennis Log προορίζονται για άτομα 16 ετών και άνω.", age16Required: "Επιβεβαιώστε ότι είστε τουλάχιστον 16 ετών.", signIn: "Σύνδεση", signUp: "Εγγραφή", email: "Email", password: "Κωδικός", name: "Όνομα", createAccount: "Δημιουργία λογαριασμού", or: "ή", continueGoogle: "Συνέχεια με Google", welcomeBack: "Καλώς ήρθες πίσω!", accountCreated: "Λογαριασμός δημιουργήθηκε!", passwordInfoLabel: "Απαιτήσεις κωδικού", passwordHelp: "Χρησιμοποίησε τουλάχιστον 8 χαρακτήρες. Δεν απαιτούνται υποχρεωτικά κεφαλαία, αριθμοί ή σύμβολα, αλλά απόφυγε πολύ συνηθισμένους ή εύκολα μαντεύσιμους κωδικούς. Κωδικοί που έχουν εμφανιστεί σε γνωστές διαρροές δεν γίνονται αποδεκτοί.", passwordTooShort: "Ο κωδικός πρέπει να περιλαμβάνει τουλάχιστον 8 χαρακτήρες.", passwordWeakLeaked: "Αυτός ο κωδικός είναι πολύ συνηθισμένος ή έχει εμφανιστεί σε γνωστή διαρροή. Δοκίμασε έναν πιο μοναδικό κωδικό.", passwordRejected: "Ο κωδικός δεν έγινε αποδεκτός. Έλεγξε τις απαιτήσεις δίπλα στο πεδίο και δοκίμασε ξανά.", passwordMinLabel: "Τουλάχιστον 8 χαρακτήρες", requirementMet: "η απαίτηση πληρούται", requirementNotMet: "η απαίτηση δεν πληρούται ακόμη", sameMethodHint: "Χρησιμοποίησε την ίδια μέθοδο σύνδεσης που χρησιμοποίησες κατά τη δημιουργία του λογαριασμού σου.", signInFailed: "Το email ή ο κωδικός είναι λανθασμένα. Αν δημιούργησες τον λογαριασμό σου με Google, συνδέσου με Google." },
  authPage: {
    heroTitle: "Ξεκίνα να χτίζεις την τενιστική σου ιστορία",
    heroSubtitle: "Κατέγραψε αγώνες σε λίγα λεπτά, εντόπισε τα μοτίβα σου και άφησε τα στατιστικά να σου δείξουν τι να βελτιώσεις στη συνέχεια.",
    trustFree: "Δωρεάν βασικές λειτουργίες",
    trustData: "Τα δεδομένα σου παραμένουν δικά σου",
    trustDevice: "Δουλεύει σε κινητό και web",
    dashboardAlt: "Πλακίδια του Tennis Log: ποσοστό νικών, σετ, games, hold rate, breaks και μετατροπή 1ου σετ",
    dashboardCaption: "Μετά από λίγους αγώνες, το dashboard σου αρχίζει να δείχνει ποσοστό νικών, hold rate, breaks, τάσεις και AI insights.",
    founderQuote: "Έφτιαξα το Tennis Log γιατί ήθελα να σταματήσω να ξεχνάω τους αγώνες μου. Το μόνο που χρειάζεται είναι να παίζεις, να θυμάσαι την εξέλιξη του σκορ και να το καταγράφεις. Είμαι σίγουρος πως θα είναι χρήσιμο και για εσάς. Απολαύστε το!",
    founderTitle: "Ιδρυτής του Tennis Log — My Tennis Ledger",
    founderLocation: "Club παίκτης προχωρημένου επιπέδου, Ελλάδα",
    notReadyTitle: "Δεν είσαι έτοιμος να εγγραφείς ακόμα;",
    notReadySub: "Εξερεύνησε το δημόσιο περιεχόμενο πρώτα — όλα ανοιχτά, χωρίς λογαριασμό.",
    viewDemoTitle: "Δες το δημόσιο demo",
    viewDemoDesc: "Δες τι αποκαλύπτει το Tennis Log μετά από ~25 αγώνες — με αληθινά γραφήματα.",
    readGuideTitle: "Διάβασε τον Οδηγό Στατιστικών",
    readGuideDesc: "Ποιες μετρικές πραγματικά έχουν σημασία και πώς να τις διαβάσεις.",
    browseBlogTitle: "Διάβασε το blog",
    browseBlogDesc: "Άρθρα για hold/break, τάση νικών, smartwatch, AI insights και mental game.",
    open: "Άνοιγμα",
  },
  common: {
    all: "Όλα", singles: "Μονά", doubles: "Διπλά", mixed: "Μικτά",
    friendly: "Φιλικά", official: "Επίσημα",
    me: "Εγώ", opponent: "Αντίπαλος", year: "Έτος", draw: "Ισοπαλία",
    cancel: "Άκυρο", save: "Αποθήκευση", saving: "Αποθήκευση...", loading: "Φόρτωση...",
    delete: "Διαγραφή", edit: "Επεξεργασία", search: "Αναζήτηση", close: "Κλείσιμο",
    matches: "αγώνες", other: "Άλλο (συμπλήρωσε)",
    loadFailed: "Δεν ήταν δυνατή η φόρτωση των δεδομένων σου", loadFailedBody: "Κάτι πήγε στραβά κατά τη φόρτωση. Έλεγξε τη σύνδεσή σου και δοκίμασε ξανά.", retry: "Δοκίμασε ξανά",
  },
  conditions: { sun: "Κόντρα ήλιος", wind: "Άνεμος", noise: "Φασαρία / κόσμος", cold: "Κρύο", rain: "Βροχή", slippery: "Ολισθηρό γήπεδο", humidity: "Υγρασία", strong_wind: "Έντονος άνεμος" },
  dashboard: {
    title: "Dashboard", subtitle: "Η εικόνα της σεζόν σου με μια ματιά.",
    newMatch: "+ Νέος αγώνας",
    statsFilter: "Φίλτρο στατιστικών", trendFilter: "Φίλτρο εξέλιξης",
    trendTitle: "Εξέλιξη win rate", recent: "Πρόσφατοι αγώνες", seeAll: "Όλα →",
    noMatches: "Κανένας αγώνας ακόμα.", addFirst: "Πρόσθεσε τον πρώτο",
    noFilter: "Δεν υπάρχουν αγώνες για αυτό το φίλτρο.",
    overallWinRate: "Συνολικό ποσοστό νικών", winRate: "Ποσοστό νικών", clickDot: "Κάνε κλικ για επεξεργασία αγώνα", sets: "Sets", games: "Games", holdRate: "Ποσοστό διατήρησης σερβίς",
    breaksWon: "Κερδισμένα break", breaksWonSub: "{{breaks}} σε {{total}} return games",
    serviceGames: "service games", returnGames: "return games",
    winAfterFirstSet: "Νίκη μετά την κατάκτηση 1ου σετ", winAfterFirstSetSub: "{{wins}} από {{total}} αγώνες", surfaceFilter: "Επιφάνεια",
    setsWon: "Κερδισμένα σετ", gamesWon: "Κερδισμένα games", breakRate: "Ποσοστό break",
    currentForm: "Τρέχουσα φόρμα", formEmpty: "Κανένας ολοκληρωμένος αγώνας ακόμα",
    trendDelta: "Win rate {{pp}} μον. vs προηγούμενους 10",
    trendStable: "Win rate σταθερό vs προηγούμενους 10",
    trendUnavailable: "Η τάση εμφανίζεται μετά από {{count}} αγώνες",
    discovery: {
      title: "Τι σου λέει το τένις σου",
      family: { improving: "Βελτίωση", edge: "Το ατού σου", watch: "Πρόσεξέ το" },
    },
  },
  match: {
    opponentPrivacyHint: "Προαιρετικό. Τα στοιχεία αφορούν άλλο πρόσωπο — καταγράψτε μόνο ό,τι βοηθά τη δική σας ανάλυση και μείνετε στα γεγονότα.",
    basics: "Βασικά", players: "Παίκτες", score: "Σκορ ανά σετ",
    invalidSetScore: "Μη έγκυρο σκορ στο σετ {{set}} — ο νικητής πρέπει να φτάσει το όριο και να προηγείται με 2.", notes: "Σημειώσεις",
    watch: "Δεδομένα από smartwatch", rating: "Αξιολόγηση παιχνιδιού (1–10)",
    surface: "Επιφάνεια", temperature: "Θερμοκρασία ({{unit}})",
    setType: "Τύπος σετ", standardSet: "Κανονικό", shortSet: "Short Set (στα 4 games)", superTb: "Super TB (10p)", tb7: "Tie-break 7p", tb11: "Tie-break 11p",
    tbPointByPoint: "Πόντο-πόντο", tbUndo: "Αναίρεση", tbClear: "Καθαρισμός", tbDecided: "Έληξε",
    date: "Ημερομηνία", time: "Ώρα", day: "Ημέρα", court: "Γήπεδο", courtCustomPlaceholder: "π.χ. Club Court #1",
    format: "Είδος παιχνιδιού", kind: "Είδος αναμέτρησης",
    set: "Σετ", firstServer: "Πρώτο σερβίς:",
    missingOpponent: "Συμπλήρωσε το όνομα του αντιπάλου για να αποθηκευτεί ο αγώνας.", missingCourt: "Συμπλήρωσε το όνομα του γηπέδου για να αποθηκευτεί ο αγώνας.",
    opponentRequired: "Αντίπαλος *", myPartner: "Συμπαίκτης μου", oppPartner: "Συμπαίκτης αντιπάλου",
    teams: "Ομάδες", teamsHint: "Η ομάδα μου (εγώ + συμπαίκτης) εναντίον της ομάδας αντιπάλων (αντίπαλος 1 + αντίπαλος 2).",
    myTeam: "Η ομάδα μου",
    opponentTeam: "Αντίπαλη ομάδα",
    opponent1: "Αντίπαλος 1",
    opponent2: "Αντίπαλος 2",
    doublesPlayersRequired: "Συμπλήρωσε τον συμπαίκτη και τους δύο αντιπάλους για να αποθηκεύσεις το διπλό.",
    age: "Ηλικία", experience: "Χρόνια εμπειρίας", backhand: "Backhand", playstyle: "Στυλ παιχνιδιού",

    notesPlaceholder: "Πώς πήγε το παιχνίδι;",
    summaryTab: "Συνοπτικός", detailedTab: "Αναλυτικός",
    watchHint: "Ανέβασε screenshot από Mi Fitness/Garmin/Apple Watch και τα πεδία θα γεμίσουν αυτόματα μέσω AI.",
    ratingHint: "Άφησε κενό όσα δεν θες να αξιολογήσεις.",
    saveMatch: "Αποθήκευση αγώνα", saveChanges: "Αποθήκευση αλλαγών",
    addTitle: "Νέος αγώνας", addSubtitle: "Συμπλήρωσε τα στοιχεία. Drop-downs για ταχύτητα.",
    editTitle: "Επεξεργασία αγώνα", editSubtitle: "Διόρθωσε στοιχεία και αποθήκευσε.",
    saved: "Αγώνας καταγράφηκε!", changesSaved: "Οι αλλαγές αποθηκεύτηκαν!", notFound: "Ο αγώνας δεν βρέθηκε",
    retired: "Υπήρξε εγκατάλειψη;",
    retiredNone: "Όχι",
    retiredYes: "Ναι",
    specialEnding: "Ειδική λήξη αγώνα",
    scoreMismatchTitle: "Το σκορ δεν συμφωνεί",
    scoreMismatchBody: "Από την εξέλιξη που κατέγραψες προκύπτει {{derived}}, ενώ στο συνολικό σκορ έχεις δηλώσει {{declared}}. Έλεγξέ το πριν συνεχίσεις.",
    scoreMismatchFix: "Διόρθωση συνολικού σκορ",
    declaredScore: "Σκορ που δήλωσες",
    declaredScoreHint: "Αυτό είναι το τελικό σκορ από το Βήμα 1. Τώρα πες μας πώς εξελίχθηκε το σετ.",
    declaredScorePrompt: "Δήλωσες ότι το <highlight>Set {{set}} έληξε {{score}}</highlight>. Τώρα πες μας πώς εξελίχθηκε το σκορ.",
    incompleteSetTimePrompt: "Δήλωσες ότι το <highlight>Set {{set}} έφτασε μέχρι το {{score}}</highlight> αλλά δεν ολοκληρώθηκε, πιθανότατα λόγω λήξης χρόνου. Συμπλήρωσε μόνο τα games που παίχτηκαν για να υπολογιστούν για το Elo.",
    timelineLiveScore: "Ζωντανό game-by-game σκορ",
    scoreMismatchBlock: "Το game-by-game σκορ δεν συμφωνεί με το τελικό σκορ. Διόρθωσε την ασυμφωνία πριν συνεχίσεις.",
    gameSequenceNext: "Συμπλήρωσε τα games με τη σειρά · Επόμενο: Game {{game}}",
    gameSequenceGap: "Λείπει το Game {{missing}} πριν από το Game {{later}}. Συμπλήρωσέ το πρώτα.",
    gameSequenceBlock: "Συμπλήρωσε τα games που λείπουν με τη σωστή σειρά πριν συνεχίσεις.",
    retiredMe: "Εγκατέλειψα εγώ",
    retiredOpp: "Εγκατέλειψε ο αντίπαλος",
    doubleFaults: "Διπλά λάθη",
    dfMe: "Δικά μου διπλά λάθη",
    dfOpp: "Διπλά λάθη αντιπάλου",
    aces: "Άσοι",
    acesMe: "Δικοί μου άσοι",
    acesOpp: "Άσοι αντιπάλου",
    context: "Πλαίσιο & συνθήκες",
    contextHint: "Εξωτερικοί και προσωπικοί παράγοντες που επηρέασαν το παιχνίδι.",
    conditions: "Φυσικές συνθήκες",
    personalIssues: "Προσωπικές δυσχέρειες",
    personalIssuesPlaceholder: "π.χ. πονοκέφαλος, ενόχληση γόνατος, κούραση…",
    psychTab: "Ψυχολογία",
    oppAge: "Ηλικία αντιπάλου",
    oppBackhand: "Backhand αντιπάλου",
    bhSingle: "Μονόχειρο",
    bhDouble: "Δίχειρο",
    oppPlaystyle: "Στυλ παιχνιδιού",
    styleOffensive: "Επιθετικό",
    styleDefensive: "Αμυντικό",
    styleAllCourt: "All-court",
    floodlights: "Με προβολείς",
    rainy: "Βροχερός καιρός",
    tiringDay: "Κουραστική / δύσκολη ημέρα στη δουλειά",
    napped: "Κοιμήθηκα το μεσημέρι",
    heavyMeal: "Έφαγα βαριά",
    fasted: "Ήμουν νηστικός",
    anxiousFlag: "Άγχος",
    tournamentRound: "Φάση τουρνουά",
    tournamentName: "Όνομα τουρνουά",
    sleepHours: "Ύπνος προηγ. βραδιάς (ώρες)",
    ballsState: "Κατάσταση μπαλών",
    ballsNew: "Καινούργιες", ballsUsed: "Παιγμένες",
    ballsUseCount: "Πόσες φορές παιγμένες",
    ballsUseSuffix: "η φορά",
    oppExperience: "Χρόνια εμπειρίας",
    racketStrungAt: "Πλέξιμο ρακέτας",
    racketStrungAgo: "πριν {{n}} ημέρες",
    racketStrungToday: "σήμερα",
    individualConditions: "Ατομικές συνθήκες",
    daysSinceLastMatch: "Ημέρες από τελευταίο αγώνα",
    daysAgo: "πριν {{n}} ημέρες",
    ballsUsed1: "Μία φορά", ballsUsed2: "Δύο φορές", ballsUsed3: "Τρεις φορές",
    oppHandedness: "Χέρι", righty: "Δεξιόχειρας", lefty: "Αριστερόχειρας",
    weightKg: "Βάρος ({{unit}})", bmi: "ΔΜΣ", bmiNoHeight: "Συμπλήρωσε ύψος στο προφίλ για υπολογισμό ΔΜΣ",
    hLegend: "H = Hold", bLegend: "B = Break",
    cellHowTo: "Ένα click στο κελί του σερβίς για Hold (H), διπλό click για Break (B). Άλλο ένα click καθαρίζει το κελί.",
    gameDetail: {
      toggle: "Πρόσθεσε λεπτομέρειες ανά game",
      toggleHint: "Προαιρετικό: πάτα ένα ολοκληρωμένο game για να καταγράψεις μέχρι πού έφτασε στο σκορ εκείνος που το έχασε.",
      gameN: "Game {{n}}",
      openSheet: "Πρόσθεσε λεπτομέρεια",
      youServed: "σέρβιρες εσύ", oppServed: "σέρβιρε ο αντίπαλος",
      held: "hold", wasBroken: "σε έκαναν break", oppHeld: "hold αντιπάλου", youBroke: "έκανες break",
      question: "Μέχρι πού έφτασε ο χαμένος του game;",
      deuce: "Deuce",
      gamePointQuestion: "Είχε ο χαμένος game point;",
      yes: "Ναι", no: "Όχι",
      clearDetail: "Καθαρισμός λεπτομέρειας", changeResult: "Αλλαγή αποτελέσματος",
      hold: "Hold", break: "Break", clearResult: "Καθαρισμός αποτελέσματος",
      token: { "0": "Ο χαμένος έφτασε στο 0", "15": "Ο χαμένος έφτασε στο 15", "30": "Ο χαμένος έφτασε στο 30", D: "Deuce, χωρίς game point", DG: "Deuce, με game point" },
    },
  },
  matches: {
    title: "Αγώνες", subtitle: "Όλο σου το ιστορικό. Φιλτράρισε & διερεύνησε.",
    searchOpponent: "Αναζήτηση αντιπάλου", searchPlaceholder: "π.χ. Αλέξης Γεωργίου",
    format: "Είδος", confrontation: "Αναμέτρηση",
    matchesCount: "{{count}} αγώνες",
    none: "Κανένας αγώνας", new: "+ Νέος",
    setGameByGame: "Σετ {{n}} — game by game",
    confirmDelete: "Διαγραφή αγώνα; Αυτή η ενέργεια δεν αναιρείται.",
    deleted: "Διαγράφηκε",
    singular: "Μονό", duplet: "Διπλό", official: "Επίσημο", friendly: "Φιλικό",
  },
  stats: {
    perGameSelectionDetails: "{{wins}} επιτυχημένα από {{total}} καταγεγραμμένα games",
    trendSelectedMatch: "Επιλεγμένος αγώνας",
    trendOpenMatch: "Προβολή αγώνα",
    tempStepLabel: "Εύρος θερμοκρασίας (°C)",
    ageStepLabel: "Εύρος ηλικίας (έτη)",
    experienceStepLabel: "Εύρος εμπειρίας (έτη)",
    byMyBmiHint: "ΔΜΣ = βάρος (kg) / ύψος² (m²). Υπολογίζεται από το ύψος στο προφίλ και το βάρος που καταγράφεις ανά αγώνα.",
    byMyBmiNone: "Δεν υπάρχουν μετρήσεις ΔΜΣ. Συμπλήρωσε ύψος στις Ρυθμίσεις και βάρος ανά αγώνα.",
    bmiBucketSize: "Εύρος BMI",
    bmiSmallSampleHint: "Πάτησε μια μπάρα για νίκες και αγώνες. Τα πολύ μικρά εύρη με λίγους αγώνες δεν δίνουν ασφαλή συμπεράσματα.",
    startTimeHalfHourHint: "Win rate ανά μισάωρο έναρξης (18:30 σημαίνει 18:30–18:59).",
    title: "Στατιστικά", subtitle: "Βαθιά ματιά στα νούμερα.",
    none: "Δεν υπάρχουν αγώνες με σκορ ακόμα.",
    allOpponents: "Όλοι οι αντίπαλοι",
    serviceStats: "Στατιστικά σερβίς", returnStats: "Στατιστικά επιστροφής",
    holds: "Holds", breaksAgainst: "Breaks εις βάρος μου", holdRate: "Hold rate ({{n}} games)",
    gamesIServed: "Games που σέρβιρα", holdRateOnServe: "Hold rate στο σερβίς μου",
    gamesIReceived: "Games που υποδέχτηκα", opponentHolds: "Holds αντιπάλου", breaksIDid: "Breaks που έκανα",
    breaksWon: "Κερδισμένα break", breakRate: "Ποσοστό break ({{n}} return games)",
    smartwatch: "Στατιστικά smartwatch", smartwatchHint: "Μέσοι όροι από τα screenshots του ρολογιού σου.",
    avgKcal: "Μέσες θερμίδες", avgDuration: "Μέση διάρκεια", avgBpm: "Μέσο BPM", maxBpm: "Μέγιστο BPM (avg)",
    perfReport: "Αναφορά απόδοσης",
    perfHint: "Μέσοι όροι αξιολόγησης (1–10) από όλους τους αγώνες όπου έχεις βαθμολογήσει.",
    perfNone: "Δεν έχεις προσθέσει αξιολογήσεις ακόμα.",
    trendTitle: "Εξέλιξη win rate", h2h: "Head-to-head",
    byCourt: "Win rate ανά γήπεδο", byDay: "Win rate ανά ημέρα",
    bySurface: "Win rate ανά επιφάνεια", byTemp: "Win rate ανά θερμοκρασία",
    surfaceNone: "Δεν έχει καταγραφεί επιφάνεια ακόμα.",
    tempNone: "Δεν έχει καταγραφεί θερμοκρασία ακόμα.",
    perGame: "Επιτυχία ανά game", set: "Σετ", scope: "Προοπτική",
    scopeAll: "Συνολικό", scopeServing: "Ξεκίνησα σερβίροντας", scopeReturning: "Ξεκίνησα υποδεχόμενος",
    metricWin: "Win rate", metricHold: "Hold rate (όταν σερβίρω)",
    fullTab: "Πλήρης", allSet: "Όλα τα σετ",
    perGameHint: "Ποσοστό επιτυχίας ανά αριθμό game.",
    firstBreakTitle: "Ποσοστό νίκης ανά πρώτο break", firstBreakHint: "Καθορίζει το πρώτο break το αποτέλεσμα;",
    fbMe: "Έκανα εγώ πρώτος break", fbOpp: "Έκανε ο αντίπαλος πρώτος break", allSurfaces: "Όλες οι επιφάνειες",
    firstServerTitle: "Ποσοστό νίκης ανά πρώτο σερβίς", firstServerHint: "Επηρεάζει το αποτέλεσμα ποιος ξεκίνησε το σερβίς;",
    fsMatch: "Όλος ο αγώνας", fsMe: "Ξεκίνησα εγώ σερβίς", fsOpp: "Ξεκίνησε ο αντίπαλος",
    returnGames: "Return games", breakRateLabel: "Break rate", gameNumber: "Game",
    hrZonesAvg: "Μέσες ζώνες καρδιακού ρυθμού",
    hrZonesAvgHint: "Μέσα λεπτά ανά ζώνη από {{n}} αγώνες με δεδομένα ρολογιού.",
    byYear: "Win rate ανά έτος", byMonth: "Win rate ανά μήνα",
    byCategoryKind: "Win rate ανά κατηγορία & είδος",
    byOppAge: "Win rate ανά ηλικία αντιπάλου", byOppAgeHint: "Κατά εύρος ηλικίας.", byOppAgeNone: "Δεν έχει καταγραφεί ηλικία αντιπάλου.",
    byOppExp: "Win rate ανά εμπειρία αντιπάλου", byOppExpHint: "Χρόνια εμπειρίας.", byOppExpNone: "Δεν έχει καταγραφεί εμπειρία αντιπάλου.",
    byOppLevel: "Win rate ανά δυναμικότητα αντιπάλου", byOppLevelHint: "Συνολικό επίπεδο αντιπάλου (1–10).", byOppLevelNone: "Δεν έχει καταγραφεί επίπεδο αντιπάλου.",
    byOppBmi: "Win rate ανά BMI αντιπάλου", byOppBmiHint: "Δείκτης Μάζας Σώματος = βάρος (kg) / ύψος² (m²).", byOppBmiNone: "Δεν έχει καταγραφεί BMI αντιπάλου. Συμπλήρωσε ύψος και βάρος αντιπάλου για να εμφανιστεί το διάγραμμα.",
    showTrend: "Εμφάνιση τάσης", hideTrend: "Απόκρυψη τάσης",
    byOppBackhand: "Win rate ανά backhand αντιπάλου", byOppBackhandNone: "Δεν έχει καταγραφεί backhand αντιπάλου.",
    byBalls: "Win rate ανά κατάσταση μπάλας", byBallsNone: "Δεν έχει καταγραφεί κατάσταση μπάλας.",
    ballsNew: "Καινούργιες", ballsUsed: "Παιγμένες", ballsUsedN: "Παιγμένες ×{{count}}",

    byRainy: "Win rate σε βροχή", byFloodlights: "Win rate με προβολείς",
    byDuration: "Win rate ανά διάρκεια αγώνα", byStartTime: "Win rate ανά ώρα έναρξης",
    byMyBmi: "Win rate ανά ΔΜΣ μου",
    byOppHandedness: "Win rate ανά χέρι αντιπάλου", byOppPlaystyle: "Win rate ανά στυλ αντιπάλου",
    byOppBirthMonth: "Win rate ανά μήνα γέννησης αντιπάλου",
    bySleep: "Win rate ανά ώρες ύπνου", byTiringDay: "Win rate μετά από κουραστική μέρα",
    byNapped: "Win rate με μεσημεριανό ύπνο", byHeavyMeal: "Win rate μετά από βαρύ γεύμα",
    byFasted: "Win rate νηστικός", byAnxious: "Win rate με άγχος",
    byCondition: "Win rate αναλόγως φυσικών συνθηκών", byPartner: "Win rate ανά συμπαίκτη",
    gameDetail: {
      whenServing: "Όταν σέρβιρα", whenReturning: "Όταν υποδεχόμουν",
      held: "Κράτησα σερβίς", broken: "Δέχτηκα break", opponentHeld: "Ο αντίπαλος κράτησε σερβίς", iBroke: "Έκανα break",
      deuce: "Ισοπαλία", pressure: "Πίεση",
      serviceCoverage: "Καταγράφηκαν λεπτομέρειες για {{detailed}} από {{total}} games σερβίς",
      returnCoverage: "Καταγράφηκαν λεπτομέρειες για {{detailed}} από {{total}} games υποδοχής",
      smallSample: "Μικρό δείγμα · n={{count}}",
      noServiceData: "Δεν υπάρχουν ακόμη αναλυτικά games σερβίς", noReturnData: "Δεν υπάρχουν ακόμη αναλυτικά games υποδοχής",
      unlock: "Πρόσθεσε λεπτομέρειες game κατά την καταγραφή για να δεις αυτή την ανάλυση.",
      serviceTooltip: "{{percentage}}% · {{count}} από {{total}} αναλυτικά games σερβίς",
      returnTooltip: "{{percentage}}% · {{count}} από {{total}} αναλυτικά games υποδοχής",
      serviceHeld: { "0": "Κράτησα σερβίς με τον υποδεχόμενο στο 0", "15": "Κράτησα σερβίς με τον υποδεχόμενο στο 15", "30": "Κράτησα σερβίς με τον υποδεχόμενο στο 30", D: "Κράτησα σερβίς μετά από ισοπαλία", DG: "Κράτησα σερβίς αφού αντιμετώπισα break point" },
      serviceBroken: { "0": "Δέχτηκα break μένοντας στο 0", "15": "Δέχτηκα break μένοντας στο 15", "30": "Δέχτηκα break μένοντας στο 30", D: "Δέχτηκα break μετά από ισοπαλία", DG: "Δέχτηκα break αφού είχα game point" },
      returnHeld: { "0": "Ο αντίπαλος κράτησε σερβίς με εμένα στο 0", "15": "Ο αντίπαλος κράτησε σερβίς με εμένα στο 15", "30": "Ο αντίπαλος κράτησε σερβίς με εμένα στο 30", D: "Ο αντίπαλος κράτησε σερβίς μετά από ισοπαλία", DG: "Ο αντίπαλος κράτησε σερβίς αφού είχα break point" },
      returnBreak: { "0": "Έκανα break με τον αντίπαλο στο 0", "15": "Έκανα break με τον αντίπαλο στο 15", "30": "Έκανα break με τον αντίπαλο στο 30", D: "Έκανα break μετά από ισοπαλία", DG: "Έκανα break αφού ο αντίπαλος είχε game point" },
    },
  },
  theme: { label: "Θέμα", court: "Νύχτα Court", clay: "Χωμάτινο", daylight: "Ημέρα", grass: "Γρασίδι", hardcourt: "Σκληρό" },
  insights: {
    pageSubtitle: "Ανάλυση των αγώνων σου με τεχνητή νοημοσύνη.",
    pickOpponent: "Αντίπαλος",
    title: "Insights", subtitle: "Μοτίβα από τα δεδομένα σου + AI προπονητής.",
    askAi: "Ρώτα το AI", generating: "Δημιουργία…", aiNarrative: "AI αφήγηση",
    notEnough: "Δεν υπάρχουν αρκετά δεδομένα ακόμα — συνέχισε να καταγράφεις.",
    aiError: "Αδυναμία δημιουργίας insights.",
  },
  insightsPreview: {
    title: "Τι θα ανακαλύψει το Tennis Log",
    subtitle: "Κατάγραψε τους αγώνες σου και το Tennis Log θα μάθει σταδιακά τα μοτίβα πίσω από τα αποτελέσματά σου.",
    learningTitle: "Τι μαθαίνει στη συνέχεια το Tennis Log",
    learningSubtitle: "Αυτές οι περιοχές χρειάζονται λίγο περισσότερο ιστορικό αγώνων πριν βγει οποιοδήποτε συμπέρασμα.",
    examplesLabel: "Παραδείγματα όσων μπορεί να ανακαλύψει το Tennis Log",
    badge: "Παράδειγμα",
    cta: "Κατάγραψε τον πρώτο σου αγώνα",
    disclaimer: "Αυτά είναι ενδεικτικά παραδείγματα, όχι συμπεράσματα για εσένα. Δεν βασίζονται στα δεδομένα σου.",
    items: {
      serve: { text: "Αποδίδεις καλύτερα σε αμφίρροπους αγώνες όταν το πρώτο σερβίς λειτουργεί.", unlock: "Κατάγραψε αξιολογήσεις σερβίς σε μερικούς αγώνες για να ξεκλειδώσει." },
      opponents: { text: "Τα αποτελέσματά σου απέναντι σε ισχυρότερους αντιπάλους βελτιώνονται.", unlock: "Κατάγραψε μερικούς ακόμη αγώνες με το επίπεδο αντιπάλου για να ξεκλειδώσει." },
      pressure: { text: "Τα αβίαστα λάθη σου αυξάνονται σε σετ υψηλής πίεσης.", unlock: "Κατάγραψε μερικούς ακόμη αγώνες για να δεις αν η πίεση επηρεάζει την απόδοσή σου." },
      surface: { text: "Κερδίζεις πιο συχνά σε μία επιφάνεια από ό,τι σε άλλη.", unlock: "Κατάγραψε αγώνες σε διαφορετικές επιφάνειες για να ξεκλειδώσει." },
    },
  },
  gaps: {
    title: "Τι δεν γνωρίζει ακόμη το Tennis Log",
    subtitle: "Όσο πιο πλήρεις γίνονται οι καταγραφές σου, τόσο πιο έξυπνος γίνεται ο προσωπικός σου AI προπονητής.",
    knowledgeTitle: "Γνώση AI",
    knowledgeHint: "Εκτίμηση του πόσες χρήσιμες πληροφορίες υπάρχουν για ουσιαστική ανάλυση AI.",
    loggedIn: "Καταγράφηκε στο {{pct}}% των αγώνων σου.",
    notYet: "Δεν υπάρχουν ακόμη δεδομένα.",
    couldReveal: "Το Tennis Log θα μπορούσε να αποκαλύψει:",
    cta: "Ξεκίνα να το καταγράφεις",
    doneTitle: "Τέλεια!",
    doneBody: "Το Tennis Log έχει ήδη αρκετά δεδομένα για insights υψηλής ποιότητας. Συνέχισε να καταγράφεις αγώνες για μεγαλύτερη βεβαιότητα και νέα μακροπρόθεσμα μοτίβα.",
    items: {
      selfRatings: {
        label: "Οι δικές σου βαθμολογίες",
        bullets: ["ποια χτυπήματα κρίνουν πραγματικά τους αγώνες σου", "πώς αλλάζει το επίπεδό σου ανά σετ", "την πρόοδό σου μέσα στη σεζόν"],
      },
      opponentRatings: {
        label: "Βαθμολογίες αντιπάλου",
        bullets: ["δυνατά σημεία που μετρούν απέναντι σε ισχυρότερους", "αδυναμίες που εμφανίζονται μόνο με ομοιόβαθμους", "εξατομικευμένη ανάλυση αναμέτρησης"],
      },
      sleep: {
        label: "Ύπνος",
        bullets: ["αν ο ύπνος επηρεάζει το ποσοστό νικών", "την αντοχή σου", "την απόδοσή σου στο τρίτο σετ"],
      },
      nutrition: {
        label: "Διατροφή",
        bullets: ["πώς τα γεύματα επηρεάζουν την απόδοση", "αν τα βαριά γεύματα μειώνουν τη σταθερότητα", "πώς η νηστεία αλλάζει την αντοχή"],
      },
      weather: {
        label: "Καιρός & συνθήκες",
        bullets: ["πώς ήλιος, αέρας ή βροχή αλλάζουν το παιχνίδι σου", "απόδοση με προβολείς", "το ιδανικό εύρος θερμοκρασίας"],
      },
      court: {
        label: "Γήπεδο & μπάλες",
        bullets: ["την καλύτερη επιφάνεια για σένα", "πώς η κατάσταση των μπαλών επηρεάζει τον ρυθμό", "ποια γήπεδα σου ταιριάζουν"],
      },
      emotions: {
        label: "Μυαλό & ενέργεια",
        bullets: ["πώς το άγχος επηρεάζει τα κρίσιμα σετ", "την επίδραση μιας κουραστικής μέρας", "πότε η ψυχραιμία γυρίζει αγώνες"],
      },
      watch: {
        label: "Smartwatch",
        bullets: ["ανίχνευση κόπωσης", "μοτίβα αποκατάστασης", "συσχετίσεις καρδιακών παλμών και έντασης"],
      },
    },
  },
  composite: {
    title: "Σύνθετα Insights",
    subtitle: "Μοτίβα που εμφανίζονται μόνο όταν συνδυαστούν πολλά στοιχεία των αγώνων σου.",
    disclaimer: "Τα σύνθετα insights περιγράφουν συσχετίσεις στα δικά σου δεδομένα, όχι αποδεδειγμένες αιτίες. Εμφανίζονται μόνο όταν το δείγμα και η διαφορά είναι αρκετά μεγάλα.",
    showMore: "Δες {{count}} ακόμη",
    showLess: "Δες λιγότερα",
    direction: {
      positive: "Θετικό εύρημα",
      negative: "Αρνητικό εύρημα",
      neutral: "Ουδέτερο εύρημα",
    },
    cat: {
      momentum: "Ροή & momentum αγώνα",
      context: "Απόδοση ανά συνθήκες",
      opponent: "Ανάλυση αντιπάλων",
      physical: "Φυσική ετοιμότητα",
      development: "Εξέλιξη",
      matchup: "Ανάλυση matchup",
    },
    ev: {
      groups: "Κέρδισες {{aWins}} από {{aSample}} αγώνες ({{aRate}}%) {{aLabel}}, έναντι {{bWins}} από {{bSample}} ({{bRate}}%) {{bLabel}}.",
      single: "Κέρδισες {{aWins}} από {{aSample}} αγώνες ({{aRate}}%).",
      ratingTrend: "Μέση αυτοαξιολόγηση {{recentAvg}} στους τελευταίους {{recentN}} αγώνες, έναντι {{prevAvg}} στους προηγούμενους {{prevN}}.",
    },
    grp: {
      metricAbove: "όταν βαθμολόγησες τον εαυτό σου πάνω από τον μέσο όρο σου {{skill}}",
      metricBelow: "όταν η βαθμολογία σου ήταν στον μέσο όρο ή χαμηλότερα",
      metricAboveSurface: "σε {{surface}} όταν βαθμολόγησες τον εαυτό σου πάνω από τον μέσο όρο σου {{skill}}",
      metricBelowSurface: "σε {{surface}} όταν η βαθμολογία σου ήταν στον μέσο όρο ή χαμηλότερα",
      lostFirstSet: "όταν έχασες το πρώτο σετ",
      wonFirstSet: "όταν κέρδισες το πρώτο σετ",
      long: "σε αγώνες πάνω από 90 λεπτά",
      short: "σε αγώνες κάτω από 90 λεπτά",
      decider: "σε αγώνες που πήγαν σε καθοριστικό σετ",
      overall: "σε όλους τους καταγεγραμμένους αγώνες",
      tiebreak: "σε αγώνες με tie-break",
      surfaceOn: "σε αυτή την επιφάνεια: {{surface}}",
      surfaceOff: "σε άλλες επιφάνειες",
      morning: "σε πρωινούς αγώνες",
      afternoon: "σε απογευματινούς και βραδινούς αγώνες",
      floodlit: "με προβολείς",
      daylight: "με φως ημέρας",
      skillBetter: "όταν βαθμολόγησες υψηλότερα αυτόν τον τομέα: {{skill}}",
      skillWorse: "όταν ο αντίπαλος ήταν υψηλότερα σε αυτόν τον τομέα",
      goodSleepLong: "σε μεγάλους αγώνες μετά από ύπνο 7 ωρών και άνω",
      lowSleepLong: "σε μεγάλους αγώνες μετά από λιγότερο ύπνο",
      goodSleepDecider: "σε αγώνες με καθοριστικό σετ μετά από ύπνο 7 ωρών και άνω",
      lowSleepDecider: "σε αγώνες με καθοριστικό σετ μετά από λιγότερο ύπνο",
      heavyMeal: "μετά από βαρύ γεύμα",
      noHeavyMeal: "χωρίς βαρύ γεύμα",
      recentPeriod: "στους τελευταίους {{n}} αγώνες",
      previousPeriod: "στους {{n}} προηγούμενους αγώνες",
      h2hLostFirst: "απέναντι σε αυτόν τον αντίπαλο όταν έχασες το πρώτο σετ",
      h2hOverall: "απέναντι σε αυτόν τον αντίπαλο συνολικά",
    },
    msg: {
      mentalPressureStrong: "Στις στιγμές πίεσης το ψυχολογικό κομμάτι κρίνει τον αγώνα {{skill}} — κέρδισες {{wins}} από {{sample}} τέτοιους αγώνες ({{rate}}%) όταν βαθμολόγησες τον εαυτό σου πάνω από τον μέσο όρο, έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) όταν όχι.",
      mentalPressureWeak: "Στις στιγμές πίεσης το ψυχολογικό κομμάτι σού κοστίζει {{skill}} — κέρδισες {{wins}} από {{sample}} τέτοιους αγώνες ({{rate}}%) όταν βαθμολόγησες τον εαυτό σου πάνω από τον μέσο όρο, έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) όταν όχι.",
      serveTightStrong: "Στα κρίσιμα σετ το σερβίς κάνει τη διαφορά {{skill}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%) όταν βαθμολόγησες τον εαυτό σου πάνω από τον μέσο όρο, έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) όταν όχι.",
      serveTightWeak: "Τα κρίσιμα σετ αναδεικνύουν μια αδυναμία {{skill}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%) όταν βαθμολόγησες τον εαυτό σου πάνω από τον μέσο όρο, έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) όταν όχι.",
      techniqueSurfaceStrong: "Σε {{surface}} ένα κομμάτι του παιχνιδιού σου κρίνει το αποτέλεσμα {{skill}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%) όταν βαθμολόγησες τον εαυτό σου πάνω από τον μέσο όρο, έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) όταν όχι.",
      techniqueSurfaceWeak: "Σε {{surface}} ένα κομμάτι του παιχνιδιού σου σε κρατάει πίσω {{skill}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%) όταν βαθμολόγησες τον εαυτό σου πάνω από τον μέσο όρο, έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) όταν όχι.",
      comebackStrong: "Ανακάμπτεις καλά όταν χάνεις το πρώτο σετ — κέρδισες {{wins}} από {{sample}} τέτοιους αγώνες ({{rate}}%).",
      comebackWeak: "Δυσκολεύεσαι να ανακάμψεις όταν χάνεις το πρώτο σετ — κέρδισες μόλις {{wins}} από {{sample}} τέτοιους αγώνες ({{rate}}%).",
      fadeLong: "Πέφτεις στους μεγάλους αγώνες — {{wins}} νίκες σε {{sample}} αγώνες άνω των 90 λεπτών ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) σε συντομότερους.",
      thriveLong: "Οι μεγάλοι αγώνες σου ταιριάζουν — {{wins}} νίκες σε {{sample}} αγώνες άνω των 90 λεπτών ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) σε συντομότερους.",
      deciderStrong: "Στα καθοριστικά σετ ανεβάζεις επίπεδο — κέρδισες {{wins}} από {{sample}} τέτοιους αγώνες ({{rate}}%), πάνω από το συνολικό σου {{baseline}}%.",
      deciderWeak: "Τα καθοριστικά σετ σού κοστίζουν — κέρδισες {{wins}} από {{sample}} τέτοιους αγώνες ({{rate}}%), κάτω από το συνολικό σου {{baseline}}%.",
      tiebreakStrong: "Τα tie-break σε ευνοούν — κέρδισες {{wins}} από {{sample}} αγώνες με tie-break ({{rate}}%), πάνω από το συνολικό σου {{baseline}}%.",
      tiebreakWeak: "Τα tie-break σού στοιχίζουν αγώνες — κέρδισες {{wins}} από {{sample}} αγώνες με tie-break ({{rate}}%), κάτω από το συνολικό σου {{baseline}}%.",
      surfaceStrong: "Αυτή η επιφάνεια σου ταιριάζει: {{surface}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) αλλού.",
      surfaceWeak: "Αυτή η επιφάνεια σε δυσκολεύει: {{surface}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) αλλού.",
      morningBetter: "Οι πρωινοί αγώνες σου δίνουν τα καλύτερα αποτελέσματα — {{wins}} από {{sample}} ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) αργότερα μέσα στην ημέρα.",
      eveningBetter: "Παίζεις καλύτερα αργότερα μέσα στην ημέρα — {{wins}} από {{sample}} ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) το πρωί.",
      floodlightsBetter: "Με προβολείς το παιχνίδι σου κρατάει — {{wins}} από {{sample}} ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) με φως ημέρας.",
      floodlightsWorse: "Οι αγώνες με προβολείς σε δυσκολεύουν — {{wins}} από {{sample}} ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) με φως ημέρας.",
      strongOppSkill: "Απέναντι σε δυνατότερους αντιπάλους ένας τομέας κρίνει τον αγώνα: {{skill}} — κέρδισες {{wins}} από {{sample}} αγώνες ({{rate}}%) όταν ήσουν υψηλότερα εκεί.",
      strongOppWeak: "Απέναντι σε δυνατότερους αντιπάλους δεν αρκεί να είσαι υψηλότερα σε έναν τομέα: {{skill}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%).",
      peerOppSkill: "Απέναντι σε αντιπάλους του επιπέδου σου ένας τομέας σου δίνει πλεονέκτημα: {{skill}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%).",
      sleepLongMatches: "Στους μεγάλους αγώνες ο ύπνος φαίνεται στα αποτελέσματα — {{wins}} από {{sample}} νίκες μετά από ύπνο 7 ωρών και άνω ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) με λιγότερο.",
      fatigueThirdSet: "Στους αγώνες που φτάνουν σε καθοριστικό σετ — {{wins}} από {{sample}} νίκες μετά από ύπνο 7 ωρών και άνω ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) με λιγότερο.",
      mealStrongOpp: "Απέναντι σε δυνατότερους αντιπάλους το βαρύ γεύμα φαίνεται — {{wins}} από {{sample}} νίκες χωρίς βαρύ γεύμα ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) με βαρύ γεύμα.",
      skillRising: "Ένας τομέας ανεβαίνει: {{skill}} — περίπου +{{diff}} μονάδες αξιολόγησης στους τελευταίους {{sample}} αγώνες.",
      skillFalling: "Ένας τομέας υποχωρεί: {{skill}} — περίπου -{{diff}} μονάδες αξιολόγησης στους τελευταίους {{sample}} αγώνες.",
      formUp: "Η πρόσφατη φόρμα σου ανεβαίνει — κέρδισες {{wins}} από τους τελευταίους {{sample}} αγώνες ({{rate}}%), έναντι {{otherWins}} από τους προηγούμενους {{otherSample}} ({{otherRate}}%), με αντιπάλους παρόμοιου επιπέδου.",
      formDown: "Η πρόσφατη φόρμα σου έπεσε — κέρδισες {{wins}} από τους τελευταίους {{sample}} αγώνες ({{rate}}%), έναντι {{otherWins}} από τους προηγούμενους {{otherSample}} ({{otherRate}}%), με αντιπάλους παρόμοιου επιπέδου.",
      matchupSkill: "Απέναντι σε {{opponent}} ένας τομέας κρίνει τις αναμετρήσεις: {{skill}} — {{wins}} νίκες σε {{sample}} αγώνες ({{rate}}%) όταν ήσουν υψηλότερα εκεί.",
      matchupFirstSet: "Απέναντι σε {{opponent}} δύσκολα γυρίζεις χαμένο πρώτο σετ — {{wins}} νίκες σε {{sample}} τέτοιους αγώνες ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) συνολικά.",
      matchupComeback: "Απέναντι σε {{opponent}} το χαμένο πρώτο σετ δεν κρίνει τίποτα — {{wins}} νίκες σε {{sample}} τέτοιους αγώνες ({{rate}}%), έναντι {{otherWins}} από {{otherSample}} ({{otherRate}}%) συνολικά.",
    },
  },
  coach: {
    driverTitle: "Καθοριστικός παράγοντας",
    driverLead: "Ένας τομέας κρίνει τους περισσότερους αγώνες σου, και προς τις δύο κατευθύνσεις: {{topic}}.",
    driverSupport: "Μέχρι τώρα: {{goodWins}} νίκες σε {{goodSample}} αγώνες ({{goodRate}}%) όταν πήγε καλά, έναντι {{badWins}} σε {{badSample}} ({{badRate}}%) όταν δεν πήγε.",
    title: "Σύνοψη AI Προπονητή",
    subtitle: "Τα πιο σημαντικά που έχει μάθει το Tennis Log από τους αγώνες σου.",
    notEnough: "Δεν υπάρχουν ακόμη αρκετοί αγώνες για συμπεράσματα — συνέχισε να καταγράφεις.",
    strengthTitle: "Μεγαλύτερο δυνατό σημείο",
    weaknessTitle: "Μεγαλύτερη αδυναμία",
    possibleStrengthTitle: "Πιθανό δυνατό σημείο",
    possibleWeaknessTitle: "Πιθανό περιθώριο βελτίωσης",
    strengthLead: "Τα δεδομένα σου δείχνουν ότι εδώ βρίσκεται το μεγαλύτερο δυνατό σου σημείο: {{topic}}.",
    weaknessLead: "Τα δεδομένα σου δείχνουν ότι εδώ βρίσκεται η μεγαλύτερη αδυναμία σου: {{topic}}.",
    strengthLeadTentative: "Υπάρχουν πρώτες ενδείξεις για δυνατό σημείο εδώ: {{topic}} — το δείγμα όμως είναι ακόμη μικρό.",
    weaknessLeadTentative: "Υπάρχουν πρώτες ενδείξεις για περιθώριο βελτίωσης εδώ: {{topic}} — το δείγμα όμως είναι ακόμη μικρό.",
    focusTitle: "Εστίαση για τον επόμενο αγώνα",
    focusOne: "Στον επόμενο αγώνα, εστίασε κυρίως εδώ: {{first}}.",
    focusTwo: "Στον επόμενο αγώνα, εστίασε κυρίως εδώ: {{first}} — και κράτα ως σταθερό σου όπλο: {{second}}.",
    disclaimer: "Πρόκειται για μοτίβα που αναδύονται από τα δικά σου δεδομένα, όχι για αποδεδειγμένη αιτιότητα.",
    confidence: {
      high: "Υψηλή αξιοπιστία",
      medium: "Μέτρια αξιοπιστία",
      low: "Χαμηλή αξιοπιστία",
    },
  },
  watch: {
    uploadScreenshot: "Μεταφόρτωση screenshot", uploading: "Ανέβασμα...", aiExtracting: "AI extract...",
    removeImage: "Αφαίρεση εικόνας", imageRequired: "Επίλεξε εικόνα (PNG/JPG)",
    uploadFailed: "Αποτυχία upload", extractFailed: "AI extract απέτυχε",
    extracted: "Δεδομένα από screenshot εξήχθησαν!",
    sourcesHint: "Από Mi Fitness, Garmin, Apple Watch, Zepp κλπ. Τα πεδία γεμίζουν αυτόματα.",
    multipleHint: "Μπορείς να ανεβάσεις περισσότερα από ένα στιγμιότυπα.",
    screenshotAlt: "Screenshot smartwatch προπόνησης",
    kcal: "Θερμίδες (kcal)", duration: "Διάρκεια (λεπτά)", avgBpm: "Μέσο BPM", maxBpm: "Μέγιστο BPM",
    hrZones: "Ζώνες καρδιακού ρυθμού", notes: "Σημειώσεις από ρολόι", notesPlaceholder: "Training effect, recovery, κλπ.",
  },
  surfaces: { hard: "Σκληρή", clay: "Χωμάτινη", grass: "Γρασίδι", carpet: "Μοκέτα" },
  ad: { label: "Διαφήμιση" },
  footer: {
    rights: "Με την επιφύλαξη παντός δικαιώματος.",
    contact: "Contact", contactTitle: "Επικοινωνία με το Tennis Ledger",
    contactHint: "Στείλε μας μήνυμα και θα σου απαντήσουμε στο email σου.",
    yourEmail: "Το email σου", subject: "Θέμα", message: "Μήνυμα", send: "Άνοιγμα email",
  },
  install: {
    iosCta: "Εγκατάσταση σε iPhone",
    platforms: "Διαθέσιμο σε Android · Λειτουργεί σε iPhone",
    iosSheetTitle: "Χρησιμοποίησε το Tennis Log σαν εφαρμογή",
    iosSheetIntro: "Πρόσθεσε το Tennis Log στην οθόνη αφετηρίας με λίγα πατήματα — χωρίς App Store.",
    iosSheetStep1: "Άνοιξε το Tennis Log στο Safari",
    iosSheetStep2: "Πάτησε το κουμπί Κοινή χρήση",
    iosSheetStep3: "Πάτησε «Προσθήκη στην οθόνη αφετηρίας»",
    iosSheetStep4: "Πάτησε «Προσθήκη»",
    iosReassurance: "Το Tennis Log θα εμφανιστεί στην οθόνη αφετηρίας και θα ανοίγει σαν εφαρμογή.",
    iosNonSafari: "Για να εγκαταστήσεις το Tennis Log στο iPhone σου, άνοιξε αυτή τη σελίδα στο Safari.",
    iosNonSafariHint: "Άνοιξε το μενού του browser και διάλεξε «Άνοιγμα στο Safari», μετά Κοινή χρήση → Προσθήκη στην οθόνη αφετηρίας.",
    iosNudgeTitle: "Κράτα το Tennis Log ένα πάτημα μακριά",
    iosNudgeBody: "Πρόσθεσέ το στην οθόνη αφετηρίας για εμπειρία εφαρμογής.",
    iosNudgeShowMe: "Δείξε μου πώς",
    iosNudgeDismiss: "Όχι τώρα",
    cta: "Κατέβασε την εφαρμογή",
    loading: "Η επιλογή εγκατάστασης φορτώνει, περίμενε λίγα δευτερόλεπτα",
    opening: "Άνοιγμα προτροπής εγκατάστασης…",
    unavailable: "Η επιλογή εγκατάστασης δεν είναι διαθέσιμη αυτή τη στιγμή",
    title: "Εγκατάσταση Tennis Log",
    hint: "Πρόσθεσε το Tennis Log στη συσκευή σου για να ανοίγει σαν κανονική εφαρμογή.",
    iosStep1: "Πάτα Κοινοποίηση",
    iosStep2: "Έπειτα επίλεξε «Προσθήκη στην οθόνη Αφετηρίας».",
    iosStep3: "Πάτα «Προσθήκη» πάνω δεξιά",
    androidStep1: "Πάτα το μενού του browser ⋮",
    androidStep2: "Επίλεξε «Εγκατάσταση εφαρμογής» ή «Προσθήκη στην αρχική οθόνη».",
    androidStep3: "Επιβεβαίωσε την εγκατάσταση",
    desktopHint: "Σε Desktop Chrome ή Edge:",
    desktopStep1: "Κάνε κλικ στο εικονίδιο εγκατάστασης στη γραμμή διευθύνσεων",
    desktopStep2: "Ή άνοιξε το μενού του browser και επίλεξε «Εγκατάσταση Tennis Log».",
  },

  profileSetup: {
    "title": "Ολοκλήρωσε το προφίλ παίκτη",
    "subtitle": "Λίγα στοιχεία κάνουν τα στατιστικά και τις αναλύσεις AI πολύ πιο ακριβή.",
    "dob": "Ημερομηνία γέννησης",
    "level": "Το επίπεδό σου (1–10)",
    "levelHint": "1 = ξεκινάς τώρα, 10 = αγωνιστικός παίκτης υψηλού επιπέδου.",
    "unitsMetric": "Μετρικό",
    "unitsUs": "ΗΠΑ",
    "later": "Αργότερα",
    "saved": "Το προφίλ ενημερώθηκε",
    "ctaTitle": "Ολοκλήρωσε το προφίλ παίκτη",
    "ctaBody": "Θέλει περίπου ένα λεπτό και βελτιώνει κάθε σύγκριση στα στατιστικά σου.",
    "ctaAction": "Ολοκλήρωση προφίλ",
    "countryPlaceholder": "Επίλεξε χώρα",
    "countrySearch": "Αναζήτηση χώρας…",
    "countryEmpty": "Δεν βρέθηκε χώρα"
  },
  settings: {
    healthConsent: "Συγκατάθεση για δεδομένα υγείας",
    healthConsentActive: "Ενεργή: επιτρέπετε στο Tennis Log να επεξεργάζεται τα δεδομένα υγείας που καταχωρίζετε στους αγώνες σας.",
    healthConsentInactive: "Ανενεργή: δεν γίνεται επεξεργασία δεδομένων smartwatch και παλμών.",
    healthConsentWithdraw: "Ανάκληση συγκατάθεσης",
    healthConsentWithdrawn: "Η συγκατάθεση ανακλήθηκε και τα δεδομένα υγείας διαγράφηκαν.",
    healthConsentPartial: "Η συγκατάθεση ανακλήθηκε. Ορισμένα δεδομένα υγείας δεν διαγράφηκαν ακόμη — δοκιμάστε ξανά σύντομα.",
    healthConsentError: "Δεν ήταν δυνατή η ενημέρωση της συγκατάθεσης. Δοκιμάστε ξανά.",
    healthConsentWithdrawHint: "Η ανάκληση της συγκατάθεσης διαγράφει οριστικά τα αποθηκευμένα screenshots από smartwatch και τα εισαγόμενα δεδομένα υγείας (παλμοί, θερμίδες κ.λπ.).",
    healthConsentWithdrawTitle: "Ανάκληση συγκατάθεσης για δεδομένα υγείας;",
    healthConsentWithdrawBody: "Η ανάκληση θα διαγράψει οριστικά τα αποθηκευμένα screenshots από smartwatch/Mi Fitness και τα εισαγόμενα δεδομένα υγείας, όπως καρδιακούς παλμούς και θερμίδες, από τους αγώνες σου. Η ενέργεια δεν μπορεί να αναιρεθεί.",
    healthConsentWithdrawKeepMatches: "Οι ίδιοι οι αγώνες σου δεν θα διαγραφούν· μόνο τα αποθηκευμένα δεδομένα smartwatch και υγείας θα αφαιρεθούν.",
    healthConsentWithdrawConfirm: "Ανάκληση και διαγραφή δεδομένων υγείας",
    title: "Ρυθμίσεις",
    profile: "Προφίλ",
    displayName: "Όνομα εμφάνισης",
    age: "Ηλικία",
    country: "Χώρα",
    gender: "Φύλο",
    gender_male: "Άνδρας", gender_female: "Γυναίκα", gender_other: "Άλλο", gender_prefer_not: "Προτιμώ να μην πω",
    level: "Επίπεδο τένις",
    level_beginner: "Αρχάριος", level_intermediate: "Μέτριος", level_advanced: "Προχωρημένος", level_competitive: "Αγωνιστικός",
    profileSaved: "Το προφίλ αποθηκεύτηκε",
    password: "Κωδικός",
    newPassword: "Νέος κωδικός",
    changePassword: "Αλλαγή κωδικού",
    pwdTooShort: "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες",
    pwdChanged: "Ο κωδικός άλλαξε",
    dataExport: "Εξαγωγή δεδομένων",
    dataExportHint: "Κατέβασε όλους τους {{count}} αγώνες σου σε αρχείο CSV.",
    exportCsv: "Εξαγωγή σε CSV",
    noMatchesExport: "Δεν υπάρχουν αγώνες για εξαγωγή.",
    exported: "Εξήχθησαν {{count}} αγώνες",
    units: "Μονάδες μέτρησης",
    unitsHint: "Επίλεξε πώς εμφανίζονται θερμοκρασίες και βάρη. Τα δεδομένα αποθηκεύονται πάντα σε °C και kg.",
    unitsMetric: "Μετρικό (°C, kg)",
    unitsUs: "ΗΠΑ (°F, lb)",
    cookiePrefs: "Προτιμήσεις cookies",
    cookiePrefsHint: "Ενημέρωσε ποιες κατηγορίες cookies επιτρέπεις.",
    manageCookies: "Διαχείριση cookies",
    diagnostics: "Εφαρμογή & Διαγνωστικά",
    diagnosticsHint: "Τεχνικές λεπτομέρειες που μας βοηθούν να αναπαράγουμε ένα πρόβλημα. Δεν περιλαμβάνεται τίποτα προσωπικό.",
    diagnosticsCopy: "Αντιγραφή διαγνωστικών",
    diagnosticsCopied: "Τα διαγνωστικά αντιγράφηκαν στο πρόχειρο",
    diagnosticsCopyFailed: "Η αντιγραφή απέτυχε — δοκίμασε ξανά",
    reportProblem: "Αναφορά προβλήματος",
    diagnosticsPasted: "Τα διαγνωστικά αντιγράφηκαν — επικολλήστε τα στο μήνυμά σας.",
    diagLanguage: "Γλώσσα",
    diagUnits: "Μονάδες",
    diagDisplay: "Τρόπος εμφάνισης",
    diagDisplayStandalone: "Εγκατεστημένη εφαρμογή (standalone)",
    diagDisplayBrowser: "Καρτέλα προγράμματος περιήγησης",
    diagBrowser: "Πρόγραμμα περιήγησης",
    diagViewport: "Παράθυρο προβολής",
    diagOrientation: "Προσανατολισμός",
    diagHostname: "Όνομα κεντρικού υπολογιστή",
    dangerZone: "Επικίνδυνη ζώνη",
    deleteAccount: "Διαγραφή λογαριασμού",
    deleteHint: "Διαγράφει μόνιμα τον λογαριασμό και όλους τους αγώνες σου. Δεν αναιρείται.",
    deleteConfirmTitle: "Διαγραφή λογαριασμού;",
    deleteConfirmDesc: "Όλοι οι αγώνες, τα στοιχεία προφίλ και η σύνδεση θα διαγραφούν οριστικά.",
    deleteForever: "Ναι, διαγραφή",
    accountDeleted: "Ο λογαριασμός διαγράφηκε",
    handedness: "Χέρι", righty: "Δεξιόχειρας", lefty: "Αριστερόχειρας", heightCm: "Ύψος ({{unit}})",
  },
  cookies: {
    title: "Η ιδιωτικότητά σου",
    intro: "Χρησιμοποιούμε cookies για τη λειτουργία της εφαρμογής και προαιρετικά για μέτρηση χρήσης. Επίλεξε τι επιτρέπεις.",
    necessary: "Απολύτως απαραίτητα",
    necessaryDesc: "Απαιτούνται για σύνδεση και βασικές λειτουργίες. Πάντα ενεργά.",
    analytics: "Στατιστικά",
    analyticsDesc: "Ανώνυμα στατιστικά χρήσης για βελτίωση.",
    marketing: "Marketing",
    marketingDesc: "Χρησιμοποιείται από διαφημιστικά δίκτυα για προσωποποίηση.",
    acceptAll: "Αποδοχή όλων",
    rejectAll: "Απόρριψη όλων",
    customize: "Προσαρμογή",
    savePrefs: "Αποθήκευση προτιμήσεων",
  },
  invite: {
    title: "Προσκάλεσε φίλο",
    subtitle: "Μοιράσου το My Tennis Ledger — σκαναρε το QR ή αντιγραψε τον σύνδεσμο.",
    copyLink: "Αντιγραφή συνδέσμου",
    share: "Κοινοποίηση",
    copied: "Ο σύνδεσμος αντιγράφηκε!",
    shareText: "Κατάγραψε την ιστορία σου στο τένις με το My Tennis Ledger:",
  },
  help: {
    eyebrow: "Κέντρο βοήθειας",
    title: "Πώς λειτουργεί το Tennis Log",
    subtitle: "Μια γρήγορη ξενάγηση σε όλα τα features, με screenshots και tips. Πάτα μια ενότητα για να μεταβείς.",
    tocTitle: "Σε αυτή τη σελίδα",
    tocTroubleshooting: "Επίλυση προβλημάτων",
    tocWhoFor: "Για ποιους είναι το Tennis Log;",
    tocAbout: "Σχετικά με το Tennis Log",
    s1Title: "Ξεκίνημα",
    s1Body: "Δημιούργησε λογαριασμό με email ή Google. Θα προσγειωθείς στο Dashboard — άδειο προς το παρόν. Πάτα «+ Νέος αγώνας» για να καταγράψεις τον πρώτο.",
    s2Title: "Το Dashboard",
    s2Body: "Έξι συνοπτικές ενδείξεις επάνω: Win rate, Sets, Games, Hold rate, Breaks won και Τρέχουσα φόρμα. Καθεμία αντανακλά το τρέχον φίλτρο (έτος, format, είδος). Από κάτω: η εξέλιξη του win rate και οι πρόσφατοι αγώνες.",
    s3Title: "Προσθήκη αγώνα",
    s3Body: "Στο New Match, ξεκίνα καταγράφοντας αντίπαλο, γήπεδο και σκορ ώστε να μη χαθεί το αποτέλεσμα. Στη συνέχεια χρησιμοποίησε τα Score Timeline, Opponent, Context, Performance Review και Smartwatch για να προσθέσεις μόνο το επίπεδο λεπτομέρειας που πραγματικά θυμάσαι. Μπορείς να αποθηκεύσεις πρώτα τον βασικό αγώνα και να επιστρέψεις αργότερα για να εμπλουτίσεις την ίδια καταγραφή.",
    s4Title: "Λίστα αγώνων",
    s4Body: "Αναζήτηση ανά αντίπαλο, φίλτρα ανά format και είδος, κλικ σε σειρά για επεξεργασία. Mαζικές ενέργειες & εξαγωγή CSV στις Ρυθμίσεις.",
    s5Title: "Στατιστικά",
    s5Body: "Βαθιά ανάλυση: head-to-head, ανά γήπεδο, επιφάνεια, θερμοκρασία, έτος/μήνα, ηλικία & εμπειρία αντιπάλου, κατάσταση μπαλών, ακόμη και βροχή ή προβολείς.",
    s6Title: "AI Insights",
    s6Body: "Πάτα «Ask AI» για coach-style αφήγηση με βάση το ιστορικό αγώνων σου. Η ανάλυση AI είναι διαθέσιμη μόλις καταγράψεις δεδομένα αγώνα και γενικά γίνεται πιο ενημερωτική όσο μεγαλώνει το ιστορικό σου. Όταν ζητάς AI Insights, αποστέλλονται μόνο φιλτραρισμένα ως προς το απόρρητο και ρητά επιτρεπόμενα δεδομένα αγώνων· τα προσωπικά αναγνωριστικά αφαιρούνται ή ψευδωνυμοποιούνται σύμφωνα με την Πολιτική Απορρήτου.",
    s7Title: "Εισαγωγή από smartwatch",
    s7Body: "Στη σελίδα νέου αγώνα, στο «Δεδομένα από smartwatch», ανέβασε screenshot από την εφαρμογή του ρολογιού σου και θα συμπληρωθούν αυτόματα kcal, διάρκεια, avg/max BPM και ζώνες HR με χρήση AI.",
    s8Title: "Εξαγωγή & διαγραφή",
    s8Body: "Από τις Ρυθμίσεις μπορείς να αλλάξεις κωδικό, να διαχειριστείς cookies, να εξάγεις τα πάντα σε CSV ή να διαγράψεις οριστικά τον λογαριασμό σου.",
    ctaTitle: "Έτοιμος να ξεκινήσεις;",
    ctaDesc: "Γρήγορα και απλά — θα δεις τα πρώτα σου στατιστικά μετά από έναν αγώνα.",
    ctaBtn: "Δημιούργησε τον λογαριασμό σου",
    troubleshootingTitle: "Επίλυση προβλημάτων",
    troubleshootingItems: [
      { q: "Δεν μπορώ να συνδεθώ", a: "Βεβαιώσου ότι χρησιμοποιείς τον ίδιο πάροχο με τον οποίο εγγράφηκες (email ή Google). Αν ξέχασες τον κωδικό, χρησιμοποίησε τον σύνδεσμο επαναφοράς στην οθόνη σύνδεσης. Αν εξακολουθείς να έχεις πρόβλημα, χρησιμοποίησε τον σύνδεσμο Επικοινωνία στο footer με το email σου." },
      { q: "Ο αγώνας μου δεν αποθηκεύτηκε", a: "Για να αποθηκεύσεις έναν αγώνα, απαιτούνται αντίπαλος και γήπεδο. Τα σκορ και οι πρόσθετες λεπτομέρειες μπορούν να προστεθούν σταδιακά. Αν δεις κόκκινο μήνυμα σφάλματος, η φόρμα σου δείχνει ποιο πεδίο λείπει. Προβλήματα δικτύου μπορούν επίσης να εμποδίσουν την αποθήκευση — δοκίμασε ξανά με σταθερή σύνδεση." },
      { q: "Τα AI insights δεν παράγονται", a: "Τα AI insights χρειάζονται τουλάχιστον λίγους καταγεγραμμένους αγώνες για να βρουν μοτίβα. Αν έχεις αρκετά δεδομένα αλλά εξακολουθείς να βλέπεις σφάλμα, η υπηρεσία AI μπορεί να έχει προσωρινό όριο — περίμενε ένα λεπτό και δοκίμασε ξανά." },
      { q: "Το screenshot από το smartwatch δεν αναλύεται", a: "Ο parser δουλεύει καλύτερα με καθαρά screenshots υψηλής αντίθεσης από Apple Watch, Garmin, Polar ή Fitbit. Κόψε στενά γύρω από τη σύνοψη της προπόνησης και βεβαιώσου ότι ο καρδιακός ρυθμός και η διάρκεια διαβάζονται." },
      { q: "Οι αριθμοί των στατιστικών δείχνουν λάθος", a: "Οι περισσότερες παραξενιές στα στατιστικά προέρχονται από έλλειψη σειράς σερβίς σε αγώνες game-by-game — χωρίς αυτή, η εφαρμογή δεν μπορεί να υπολογίσει holds και breaks. Επεξεργάσου τον αγώνα και έλεγξε ποιος σερβίρισε πρώτος σε κάθε σετ." },
    ],
    whoTitle: "Για ποιους είναι το Tennis Log;",
    whoIntro: "Το Tennis Log φτιάχτηκε για κάθε παίκτη που θέλει να πάρει το τένις του λίγο πιο σοβαρά από το να θυμάται απλώς το σκορ στον δρόμο της επιστροφής. Λειτουργεί εξίσου καλά είτε παίζεις τρεις μήνες είτε τρεις δεκαετίες — το βάθος του εργαλείου κλιμακώνεται με το βάθος του ιστορικού σου.",
    whoBeginnersTitle: "Αρχάριοι",
    whoBeginnersBody: "Αν μόλις ξεκίνησες να παίζεις, το πιο χρήσιμο που σου δίνει το Tennis Log είναι ένα απλό, δομημένο αρχείο των πρώτων σου αγώνων. Δεν χρειάζεται να καταγράφεις holds και breaks ακόμα. Απλά κατάγραψε αντίπαλο, σκορ, επιφάνεια και μια σημείωση μιας γραμμής. Μετά από 10-15 αγώνες, θα έχεις μια βάση να κοιτάς πίσω σε έξι μήνες και να λες «είμαι σαφώς καλύτερος τώρα», με αποδείξεις αντί για συναισθήματα.",
    whoIntermediateTitle: "Παίκτες ενδιάμεσου επιπέδου",
    whoIntermediateBody: "Για παίκτες ομίλων και πρωταθλημάτων, το Tennis Log είναι ιδιαίτερα χρήσιμο. Η game-by-game καταγραφή παρέχει πραγματικά ποσοστά hold και break. Η ανάλυση AI είναι διαθέσιμη μόλις καταγράψεις δεδομένα αγώνα και γενικά γίνεται πιο ενημερωτική όσο μεγαλώνει το ιστορικό σου. Τα φίλτρα επιφάνειας και αντιπάλου βοηθούν να διερευνήσεις διαφορές, ενώ ένα δομημένο αρχείο αγώνων μπορεί να σου δώσει σαφέστερα ερωτήματα για την προπόνηση ή μια συνεδρία με προπονητή.",
    whoCompetitiveTitle: "Αγωνιστικοί παίκτες",
    whoCompetitiveBody: "Αν αγωνίζεσαι σε τουρνουά ή σοβαρό πρωτάθλημα, το Tennis Log λειτουργεί ως προσωπική βάση δεδομένων απόδοσης. Κατάγραψε συνθήκες, handedness αντιπάλου, βαθμολογίες και των δύο πλευρών, δεδομένα smartwatch, ψυχολογικές σημειώσεις — και τεμάχισε τα στατιστικά ανά έτος, επιφάνεια, είδος (φιλικό vs επίσημο), partner και άλλα. Εξάγαγε σε CSV ανά πάσα στιγμή και πάρε τα δεδομένα σε προπονητική συνεδρία.",
  },
  landing: {
    heroEyebrow: "Το έξυπνο ημερολόγιο τένις",
    heroTitle: "Σταμάτα να μαντεύεις. Ξεκίνα να μελετάς το τένις σου.",
    heroDesc: "Το Tennis Log είναι ένα όμορφο ημερολόγιο για ερασιτέχνες και αγωνιστικούς παίκτες. Κατέγραψε κάθε αγώνα, δες βαθιά στατιστικά και άσε την AI να βρει τα μοτίβα που σε κρατούν πίσω.",
    featuresTitle: "Όλα όσα χρειάζεσαι, τίποτα περιττό",
    f1Title: "Κατέγραψε κάθε αγώνα σε δευτερόλεπτα",
    f1Desc: "Σκορ ανά σετ, αντίπαλος, γήπεδο, επιφάνεια, καιρός, ακόμη και τα διπλά λάθη σου — γρήγορα drop-down κάνουν τα πάντα εύκολα.",
    f2Title: "Στατιστικά που πραγματικά μετράνε",
    f2Desc: "% νικών, % διατήρησης σερβίς, % break, σετ, games, απόδοση ανά επιφάνεια, γήπεδο και αντίπαλο.",
    f3Title: "AI Insights",
    f3Desc: "Πάρε μια ανάλυση τύπου προσωπικού προπονητή — τα δυνατά σου, τις αδυναμίες σου και μοτίβα από όλο σου το ιστορικό.",
    f4Title: "Εισαγωγή από smartwatch",
    f4Desc: "Ανέβασε ένα screenshot από Mi Fitness, Garmin, Apple Watch ή Zepp — η AI συμπληρώνει θερμίδες, BPM και ζώνες καρδιακής συχνότητας.",
    f5Title: "Παρακολούθηση game-by-game",
    f5Desc: "Θες να εμβαθύνεις; Κατέγραψε ακολουθίες πόντο-πόντο και ανακάλυψε τα ποσοστά επιτυχίας ανά game.",
    f6Title: "7 γλώσσες",
    f6Desc: "EN · EL · ES · FR · DE · IT · JA — το ιστορικό τένις σου στη γλώσσα σου.",
    previewTitle: "Μια ματιά μέσα",
    shotDashLabel: "Πίνακας", shotDashTitle: "Η σεζόν σου με μια ματιά",
    shotDashDesc: "Έξι συνοπτικές ενδείξεις λένε την ιστορία: ποσοστό νικών, σετ, games, hold rate, breaks και Τρέχουσα φόρμα. Καθεμία αντανακλά τα επιλεγμένα φίλτρα.",
    shotAddLabel: "Νέος αγώνας", shotAddTitle: "Κατέγραψε έναν αγώνα σε λιγότερο από ένα λεπτό",
    shotAddDesc: "Ξεκίνησε με το Fast Track για να αποθηκεύσεις τα βασικά και πρόσθεσε όσες λεπτομέρειες θέλεις μέσω των Score Timeline, Opponent, Context, Performance Review και Smartwatch.",
    shotStatsLabel: "Στατιστικά", shotStatsTitle: "Βαθιά ανάλυση των αριθμών",
    shotStatsDesc: "Μονά vs διπλά, φιλικά vs επίσημα, % διατήρησης σερβίς, % break, games υποδοχής — κάθε στατιστικό όπως το θες.",
    shotTrendLabel: "Τάση νικών", shotTrendTitle: "Δες την φόρμα σου να εξελίσσεται",
    shotTrendDesc: "Φιλτράρισε ανά μονά, διπλά, φιλικά ή επίσημα — και δες το κυλιόμενο % νικών σου να αλλάζει αγώνα με αγώνα.",
    shotPerfLabel: "Απόδοση", shotPerfTitle: "Βαθμολόγησε τον εαυτό σου και τον αντίπαλο",
    shotPerfDesc: "Βαθμολόγησε forehand, backhand, σερβίς, return, volley, drop shot, lob, αντοχή, ταχύτητα και τακτική — και για τις δύο πλευρές — και δες τα σε γράφημα radar.",
    shotPerGameLabel: "Επιτυχία ανά game", shotPerGameTitle: "Βρες το αδύναμο game σου",
    shotPerGameDesc: "Ανακάλυψε αν λυγίζεις στο game 3 ή κλείνεις το game 11 — αναλυμένο ανά πλευρά σερβίς και σετ.",
    shotWatchLabel: "Smartwatch", shotWatchTitle: "Καρδιά, θερμίδες, ζώνες — αυτόματα",
    shotWatchDesc: "Ανέβασε ένα screenshot από την εφαρμογή του ρολογιού σου και η AI συμπληρώνει θερμίδες, διάρκεια, μέσο BPM, max BPM και ζώνες καρδιακής συχνότητας.",
    howTitle: "Πώς λειτουργεί",
    s1Title: "Πρόσθεσε έναν αγώνα", s1Desc: "Πάτα «+ Νέος αγώνας», συμπλήρωσε σκορ, αντίπαλο και συνθήκες. Λιγότερο από ένα λεπτό.",
    s2Title: "Δες τα στατιστικά σου να μεγαλώνουν", s2Desc: "Ο πίνακας ενημερώνεται άμεσα. Φιλτράρισε ανά έτος, μορφή, τύπο — όπως θες.",
    s3Title: "Ρώτησε τον AI προπονητή", s3Desc: "Μετά από ~10 αγώνες, το AI Insights βρίσκει μοτίβα: πού λυγίζεις, πού λάμπεις.",
    s4Title: "Βελτιώσου, αγώνα με αγώνα", s4Desc: "Εντόπισε τι δουλεύει και διπλασίασέ το. Εξάγαγε σε CSV οποτεδήποτε.",
    trust1Title: "Ιδιωτικό & ασφαλές", trust1Desc: "Τα δεδομένα σου είναι δικά σου. Κρυπτογραφημένα, δεν πωλούνται ποτέ.",
    trust2Title: "Φτιαγμένο για παίκτες", trust2Desc: "Σχεδιασμένο από παίκτες τένις, για παίκτες τένις.",
    trust3Title: "Δικό σου, σε 7 γλώσσες", trust3Desc: "EN · EL · ES · FR · DE · IT · JA.",
    faqTitle: "Συχνές ερωτήσεις",
    faq1Q: "Πόσο κοστίζει το Tennis Log;", faq1A: "Σήμερα, όλες οι λειτουργίες είναι διαθέσιμες χωρίς κόστος — υποστηρίζονται από μικρές διαφημίσεις. Στο μέλλον ίσως εισάγουμε προαιρετικά πλάνα επί πληρωμή για προηγμένες λειτουργίες.",
    faq2Q: "Πρέπει να καταγράφω κάθε πόντο;", faq2A: "Καθόλου. Η πιο γρήγορη καταγραφή είναι μόνο ημερομηνία + αντίπαλος + σκορ σετ. Η λεπτομερής game-by-game καταγραφή είναι προαιρετική.",
    faq3Q: "Πώς δουλεύει η εισαγωγή από smartwatch;", faq3A: "Τράβα ένα screenshot της σύνοψης προπόνησης σε οποιαδήποτε εφαρμογή ρολογιού, ανέβασέ το και η AI εξάγει θερμίδες, διάρκεια, μέσο και max BPM, καθώς και ζώνες καρδιακής συχνότητας.",
    faq4Q: "Μπορώ να εξάγω τα δεδομένα μου;", faq4A: "Ναι — εξάγαγε τα πάντα σε CSV οποτεδήποτε από τις Ρυθμίσεις.",
  },
}

data.insightsH = {
  "overall": "Συνολικό win rate",
  "overallDetail": "{{rate}}% σε {{sample}} αγώνες με αποτέλεσμα.",
  "better": "Καλύτερος {{skill}} από αντίπαλο",
  "betterDetail": "Όταν είσαι καλύτερος {{skill}}, κερδίζεις {{rate}}% ({{sample}} αγώνες). Baseline: {{baseline}}%.",
  "worse": "Χειρότερος {{skill}} από αντίπαλο",
  "worseDetail": "Όταν είσαι χειρότερος {{skill}}, κερδίζεις {{rate}}% ({{sample}} αγώνες).",
  "condDetail": "{{rate}}% σε {{sample}} αγώνες (baseline {{baseline}}%).",
  "cond": {
    "oneHanded": "Vs μονόχειρο backhand",
    "twoHanded": "Vs δίχειρο backhand",
    "lowSleep": "Λίγος ύπνος (<6h)",
    "goodSleep": "Καλός ύπνος (≥7h)",
    "tiring": "Κουραστική μέρα",
    "floodlights": "Με προβολείς",
    "rainy": "Βροχερός καιρός",
    "napped": "Κοιμήθηκα το μεσημέρι",
    "heavyMeal": "Έφαγα βαριά",
    "fasted": "Νηστικός",
    "anxious": "Με άγχος",
    "newBalls": "Καινούργιες μπάλες",
    "official": "Επίσημα παιχνίδια",
    "friendly": "Φιλικά παιχνίδια",
    "singles": "Μονά",
    "doubles": "Διπλά",
    "surface": "Επιφάνεια: {{surface}}"
  },
  "skill": {
    "shot_accuracy": "ακρίβεια χτυπημάτων",
    "call_accuracy": "ακρίβεια στα calls",
    "confrontational_tendency": "ηρεμία στις αντιπαραθέσεις",
    "forehand": "στο forehand",
    "backhand": "στο backhand",
    "service": "στο σερβίς",
    "return": "στην επιστροφή σερβίς",
    "volley": "στο βόλεϊ",
    "drop_shot": "στο drop shot",
    "lob": "στο λομπ",
    "stamina": "στην αντοχή",
    "speed": "στην ταχύτητα",
    "unforced_errors": "στον έλεγχο των αβίαστων λαθών",
    "winners": "στα winners",
    "tactics": "στην τακτική",
    "awareness": "στην αντίληψη του γηπέδου",
    "shot_variety": "στην ποικιλία χτυπημάτων",
    "court_coverage": "στην κάλυψη του γηπέδου",
    "fh_topspin": "στο topspin forehand",
    "fh_slice": "στο slice forehand",
    "bh_topspin": "στο topspin backhand",
    "bh_slice": "στο slice backhand",
    "first_serve": "στο 1ο σερβίς",
    "first_serve_pct": "στο ποσοστό 1ου σερβίς",
    "first_serve_speed": "στην ταχύτητα 1ου σερβίς",
    "second_serve": "στο 2ο σερβίς",
    "second_serve_pct": "στο ποσοστό 2ου σερβίς",
    "second_serve_speed": "στην ταχύτητα 2ου σερβίς",
    "serve_flat": "στο flat σερβίς",
    "serve_kick": "στο kick σερβίς",
    "serve_slice": "στο slice σερβίς",
    "smash": "στο σμας",
    "passing_shots": "στα passing shots",
    "composure": "στην ψυχραιμία υπό πίεση",
    "concentration": "στη συγκέντρωση",
    "calmness": "στην ηρεμία",
    "anxiety": "στον έλεγχο του άγχους",
    "confidence": "στην αυτοπεποίθηση",
    "fighting_spirit": "στην αγωνιστικότητα",
    "mental_resilience": "στην ψυχική ανθεκτικότητα",
    "belief_pre": "στην πίστη πριν τον αγώνα",
    "belief_in": "στην πίστη μέσα στον αγώνα"
  }
};
data.days = ["Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο"];

data.quicklog = {
  "learnedAccordion": "Δες τι έχει μάθει το Tennis Log μέχρι τώρα",
  "savedIndicator": "Αποθηκεύτηκε",
  "fastTrackEyebrow": "Γρήγορη Καταχώριση",
  "fastTrackTagline": "Κατέγραψε έναν αγώνα σε λιγότερο από 30 δευτερόλεπτα.",
  "revealMore": "Θέλεις πιο πλούσιες απαντήσεις; Αποκάλυψε περισσότερα παρακάτω ↓",
  "bonus": "Μπόνους",
  "continue": "Συνέχεια",
  "meterTitle": "Πλέον, το Tennis Log μπορεί να υπολογίσει:",
  "meterSubtitle": "Αυτές οι πληροφορίες είναι διαθέσιμες σήμερα, με βάση τους αγώνες που καταγράφεις.",
  "meterMoreTitle": "Αποκάλυψε περισσότερα για να απαντηθεί",
  "meterInfoAria": "Σχετικά με αυτές τις πληροφορίες",
  "editScore": "Επεξεργασία σκορ",
  "timelineNoScore": "Δεν έχει καταχωρηθεί σκορ ακόμη",
  "answers": {
    "winRate": "Συνολικό ποσοστό νικών",
    "history": "Ιστορικό αγώνων",
    "gamesPct": "% κερδισμένων games",
    "setsPct": "% κερδισμένων set",
    "monthly": "Ποσοστό νικών ανά μήνα",
    "dayOfWeek": "Ποσοστό νικών ανά ημέρα εβδομάδας",
    "headToHead": "Head-to-head με αυτόν τον αντίπαλο"
  },
  "future": {
    "opponent": "Ποιοι τύποι αντιπάλων ταιριάζουν στο παιχνίδι σου",
    "timeline": "Πώς εξελίσσονται πραγματικά οι αγώνες σου",
    "context": "Ποιες συνθήκες σε βοηθούν να παίξεις καλύτερα",
    "review": "Ποιες από τις δικές σου δεξιότητες σε κερδίζουν αγώνες",
    "watch": "Τι λέει το smartwatch για την προσπάθειά σου"
  },
  "stepTitles": {
    "fastTrack": "Γρήγορη Καταχώριση",
    "opponent": "Αντίπαλος",
    "timeline": "Εξέλιξη Σκορ",
    "context": "Πλαίσιο & Συνθήκες",
    "review": "Αξιολόγησε την Απόδοσή σου",
    "watch": "Smartwatch"
  },
  "stepIntros": {
    "opponent": "Πρόσθεσε στοιχεία του αντιπάλου για να χτίσει το Tennis Log πληρέστερη εικόνα του ποιον παίζεις. Έτσι θα γίνει δυνατή βαθύτερη ανάλυση.",
    "timeline": "Κατέγραψε πώς εξελίχθηκε κάθε set. Έτσι θα γίνει δυνατή βαθύτερη ανάλυση των μοτίβων των αγώνων σου.",
    "context": "Κατέγραψε τις συνθήκες του αγώνα. Έτσι θα γίνει δυνατή βαθύτερη ανάλυση του πλαισίου.",
    "review": "Αξιολόγησε τη δική σου απόδοση. Έτσι θα γίνει δυνατή βαθύτερη ανάλυση των δεξιοτήτων σου.",
    "watch": "Έχεις smartwatch; Ανέβασε ένα screenshot και άσε την AI να συμπληρώσει τα πάντα αυτόματα."
  },
  "stepUnlocksLabel": "Θα αρχίσεις να τροφοδοτείς ανάλυση για:",
  "unlocks": {
    "opponent": [
      "Αποτελέσματα κόντρα σε αριστερόχειρες αντιπάλους",
      "Αποτελέσματα κόντρα σε έμπειρους παίκτες",
      "Αποτελέσματα ανά στυλ παιχνιδιού αντιπάλου",
      "Αποτελέσματα κόντρα σε μονόχειρα backhand"
    ],
    "timeline": [
      "Πώς κερδίζεις και χάνεις τα set σου",
      "Μοτίβα break και hold",
      "Συνέπεια σερβίς μεταξύ set"
    ],
    "context": [
      "Πώς οι συνθήκες επηρεάζουν το παιχνίδι σου",
      "Αν ο ύπνος ή η ξεκούραση επηρεάζουν τα αποτελέσματα",
      "Πώς σχετίζεται ο καιρός με την απόδοσή σου"
    ],
    "review": [
      "Ποιες δεξιότητες συσχετίζονται με τις νίκες σου",
      "Ποιες αδυναμίες σου κοστίζουν αγώνες",
      "Πώς εξελίσσονται οι βαθμολογίες σου με τον χρόνο"
    ],
    "watch": [
      "Θερμίδες και διάρκεια",
      "Μέσος και μέγιστος καρδιακός παλμός",
      "Φόρτος προπόνησης και αποκατάσταση"
    ]
  },
  "successTitle": "Ο αγώνας αποθηκεύτηκε.",
  "successBody": "Το Tennis Log μπορεί ήδη να απαντήσει σε αυτές τις ερωτήσεις για το τένις σου:",
  "successCtaMatches": "Δες τους αγώνες μου",
  "successCtaContinue": "Πρόσθεσε περισσότερα στοιχεία αγώνα — προαιρετικά",

  "addMoreDetails": "Πρόσθεσε περισσότερα στοιχεία",
  "finish": "Ολοκλήρωση & αποθήκευση",
  "wantRicher": "Θέλεις πιο πλούσιες απαντήσεις;",
  "prev": "Πίσω",
  "stepOf": "Βήμα {{current}} από {{total}}",
  "dontShowRewards": "Να μην εμφανίζονται ξανά",
  "canLabel": "Το Tennis Log μπορεί ήδη να εντοπίσει:",
  "learnedLabel": {
    "match": "Τι έμαθε το Tennis Log από αυτόν τον αγώνα:",
    "matches": "Τι έμαθε το Tennis Log από τους αγώνες σου:",
    "tennis": "Τι γνωρίζει το Tennis Log για το τένις σου:"
  },
  "hintLabel": "Έχεις άλλο ένα λεπτό;",
  "rewardTitles": {
    "fastTrack": "Ο αγώνας αποθηκεύτηκε!",
    "timeline": "Εξαιρετικά!",
    "opponent": "Πολύ ωραία!",
    "context": "Μπράβο!",
    "review": "Φανταστικά!"
  },
  "rewardBodies": {
    "fastTrack": "Ο αγώνας σου είναι πλέον μέρος του ιστορικού σου.",
    "timeline": "Το Tennis Log καταλαβαίνει πλέον πολύ περισσότερα για το πώς εξελίσσονται οι αγώνες σου.",
    "opponent": "Το Tennis Log γνωρίζει πλέον πολύ περισσότερα για τους παίκτες που αντιμετωπίζεις.",
    "context": "Το Tennis Log μπορεί τώρα να συνδέσει την απόδοσή σου με τις συνθήκες του αγώνα.",
    "review": "Η αξιολόγηση της απόδοσής σου δίνει στο Tennis Log πλούσιο υλικό για μακροχρόνια insights."
  },
  "rewardHints": {
    "fastTrack": "Συμπλήρωσε το επόμενο βήμα και το Tennis Log θα αρχίσει να ανακαλύπτει:",
    "timeline": "Στη συνέχεια θα βοηθήσεις το Tennis Log να καταλάβει τους αντιπάλους σου.",
    "opponent": "Στη συνέχεια θα καταγράψεις τις συνθήκες του αγώνα.",
    "context": "✨ Έχεις άλλο ένα λεπτό; Ας αξιολογήσουμε τώρα την απόδοση και των δύο παικτών.",
    "review": "Ένα τελευταίο προαιρετικό βήμα: σύνδεσε το smartwatch σου."
  }
};

// --- Progressive logging refinement (conversation-first copy) ---
Object.assign(data.match, {
  "oppGender": "Φύλο αντιπάλου *",
  "genderMale": "Άνδρας",
  "genderFemale": "Γυναίκα",
  "genderOther": "Άλλο",
  "oppLevel": "Συνολικό επίπεδο αντιπάλου",
  "oppLevel1": "Εντελώς αρχάριος",
  "oppLevel5": "Μέσος παίκτης ομίλου",
  "oppLevel10": "Ο καλύτερος που αντιμετώπισα",
  "oppLevelHint": "7 = δυνατός παίκτης ομίλου · 9 = αγωνιστικό επίπεδο",
  "oppBirthYear": "Έτος γέννησης",
  "oppBirthMonth": "Μήνας",
  "oppBirthDay": "Ημέρα",
  "oppTennisSince": "Παίζει τένις από (έτος)",
  "oppTennisSinceCompact": "Παίζει από",
  "oppLegacyValue": "καταχωρισμένο παλαιότερα",
  "oppBirthInvalid": "Γράψε πλήρες έτος γέννησης 4 ψηφίων (από το 1900 και μετά).",
  "oppAgePrev": "Ηλικία που είχε καταχωριστεί παλαιότερα",
  "oppExperiencePrev": "Έτη εμπειρίας που είχαν καταχωριστεί παλαιότερα",
  "oppSinceBeforeBirth": "Το έτος έναρξης τένις δεν μπορεί να είναι πριν από το έτος γέννησης.",
  "oppSinceFuture": "Το έτος έναρξης τένις δεν μπορεί να είναι στο μέλλον.",
  "oppSinceRange": "Γράψε πλήρες έτος 4 ψηφίων (από το 1900 και μετά).",
  "oppStyleScore": "Αμυντικός ↔ επιθετικός",
  "oppStyleLegacy": "Είχε καταχωριστεί ως: {{value}}",
  "oppLevelAvg": "Μέσος όρος προηγούμενων αγώνων: {{value}} ({{n}})",
  "oppLevelHistory": "Ιστορικό επιπέδου",
  "oppAttackTags": "Πού με πλήγωνε",
  "oppErrorTags": "Πού έκανε λάθη",
  "oppTagRemembered": "Είχε καταγραφεί σε προηγούμενο αγώνα",
  "attackGroup_serve": "Σερβίς & πρώτο χτύπημα",
  "attackGroup_shape": "Ποιότητα χτυπήματος",
  "attackGroup_target": "Στόχευση",
  "errorGroup_technical": "Τεχνικά",
  "errorGroup_situational": "Καταστάσεις",
  "attackTag_big_first_serve": "Δυνατό πρώτο σερβίς",
  "attackTag_aggressive_return": "Επιθετικές επιστροφές",
  "attackTag_serve_volley": "Σερβίς-βολέ",
  "attackTag_takes_ball_early": "Παίρνει νωρίς την μπάλα",
  "attackTag_heavy_topspin": "Βαρύ τοπ σπιν",
  "attackTag_frequent_slice": "Συχνό σλάις",
  "attackTag_drop_shots": "Drop shot",
  "attackTag_short_angles": "Κοντές γωνίες",
  "attackTag_effective_lobs": "Αποτελεσματικά λομπ",
  "attackTag_attacks_my_backhand": "Χτυπά το backhand μου",
  "attackTag_attacks_my_forehand": "Χτυπά το forehand μου",
  "attackTag_net_rusher": "Ανεβαίνει στο φιλέ",
  "attackTag_open_court": "Ανοίγει το γήπεδο",
  "attackTag_changes_direction": "Αλλάζει κατεύθυνση",
  "errorTag_backhand_breaks_down": "Λάθη από το backhand του",
  "errorTag_forehand_breaks_down": "Λάθη από το forehand του",
  "errorTag_high_balls": "Δυσκολεύεται σε ψηλές μπάλες",
  "errorTag_low_balls": "Δυσκολεύεται σε χαμηλές μπάλες",
  "errorTag_vs_heavy_topspin": "Δυσκολεύεται στο βαρύ τοπ σπιν",
  "errorTag_vs_slice": "Δυσκολεύεται στο σλάις",
  "errorTag_vs_drop_shots": "Δυσκολεύεται στα drop shot",
  "errorTag_volley_errors": "Λάθη στη βολέ",
  "errorTag_return_errors": "Λάθη στην επιστροφή σερβίς",
  "errorTag_second_serve_errors": "Αδύναμο δεύτερο σερβίς",
  "errorTag_errors_when_rushed": "Λάθη όταν πιέζεται χρονικά",
  "errorTag_errors_on_the_run": "Λάθη στο τρέξιμο",
  "errorTag_overhits": "Χτυπά υπερβολικά δυνατά",
  "errorTag_long_rallies": "Λάθη σε μεγάλα ράλι",
  "errorTag_under_pressure": "Λάθη υπό πίεση",
  "oppLevelEmpty": "Σύρε για να βαθμολογήσεις το συνολικό επίπεδο του αντιπάλου.",
  "oppLevelDesc_10": "Εντελώς αρχάριος",
  "oppLevelDesc_15": "Μόλις ξεκίνησε να μαθαίνει",
  "oppLevelDesc_20": "Αρχάριος με ελάχιστη εμπειρία αγώνων",
  "oppLevelDesc_25": "Αναπτύσσει βασική σταθερότητα",
  "oppLevelDesc_30": "Περιστασιακός ερασιτέχνης",
  "oppLevelDesc_35": "Βελτιούμενος ερασιτέχνης",
  "oppLevelDesc_40": "Τακτικός ερασιτέχνης παίκτης",
  "oppLevelDesc_45": "Αξιόπιστος ερασιτέχνης παίκτης",
  "oppLevelDesc_50": "Μέσος παίκτης συλλόγου",
  "oppLevelDesc_55": "Ανταγωνιστικός παίκτης συλλόγου",
  "oppLevelDesc_60": "Δυνατός παίκτης συλλόγου",
  "oppLevelDesc_65": "Πολύ δυνατός παίκτης συλλόγου",
  "oppLevelDesc_70": "Προχωρημένος παίκτης συλλόγου",
  "oppLevelDesc_75": "Δυνατός παίκτης τοπικών διοργανώσεων",
  "oppLevelDesc_80": "Υψηλού επιπέδου παίκτης διοργανώσεων",
  "oppLevelDesc_85": "Πολύ δυνατός αγωνιστικός παίκτης",
  "oppLevelDesc_90": "Κορυφαίος ερασιτέχνης / περιφερειακό επίπεδο",
  "oppLevelDesc_95": "Εξαιρετικά υψηλού επιπέδου παίκτης",
  "oppLevelDesc_100": "Ο καλύτερος παίκτης που έχω δει",
  "oppAttackNotes": "Πώς επιτίθεται αυτός ο αντίπαλος;",
  "oppAttackNotesPlaceholder": "π.χ. δυνατό σερβίς, επιτίθεται νωρίς στην μπάλα…",
  "oppErrorNotes": "Πώς κάνει λάθη αυτός ο αντίπαλος;",
  "oppErrorNotesPlaceholder": "π.χ. δυσκολεύεται όταν πιέζεται στο backhand…"
});
data.quicklog.stepTitles.review = "Αξιολόγηση Παικτών";
Object.assign(data.quicklog.stepIntros, {
  "fastTrack": "Καταχώρισε μόνο τα απολύτως βασικά. Χρειάζεσαι περίπου 30 δευτερόλεπτα.",
  "timeline": "Πώς εξελίχθηκε ο αγώνας;",
  "opponent": "Πες μας λίγα λόγια για τον αντίπαλό σου.",
  "context": "Οι λεπτομέρειες κάνουν τη διαφορά.",
  "review": "Αξιολόγησε την απόδοση και των δύο παικτών. Με τον χρόνο το Tennis Log θα ανακαλύψει ποια στοιχεία οδηγούν στις νίκες σου.",
  "watch": "Έχεις smartwatch; Άφησε το Tennis Log να συμπληρώσει τα υπόλοιπα."
});
Object.assign(data.quicklog.rewardTitles, {
  "fastTrack": "Τέλεια!",
  "timeline": "Εξαιρετικά!",
  "opponent": "Υπέροχα!",
  "context": "Τέλεια!",
  "review": "Εξαιρετική δουλειά!",
  "watch": "Όλα έτοιμα!"
});
Object.assign(data.quicklog.rewardBodies, {
  "fastTrack": "Ο αγώνας σου είναι πλέον μέρος της προσωπικής σου ιστορίας.",
  "timeline": "Το Tennis Log καταλαβαίνει πλέον πολύ καλύτερα πώς εξελίσσονται οι αγώνες σου.",
  "opponent": "Το Tennis Log γνωρίζει πλέον πολύ περισσότερα για τους αντιπάλους που αντιμετωπίζεις.",
  "context": "Η προσωπική σου βάση δεδομένων μόλις έγινε ακόμη πιο έξυπνη — το Tennis Log αρχίζει να συνδέει την απόδοσή σου με τις συνθήκες του αγώνα.",
  "review": "Το προφίλ σου έγινε πολύ πιο πλούσιο — όπως και του αντιπάλου σου. Το Tennis Log μπορεί πλέον να ανακαλύψει ποια στοιχεία σού χαρίζουν νίκες.",
  "watch": "Μόλις δημιούργησες μια από τις πληρέστερες καταγραφές αγώνα στο τενιστικό σου ταξίδι. Ευχαριστούμε που βοηθάς το Tennis Log να καταλάβει το τένις σου."
});

data.guest = {
  "tryNow": "Δοκίμασέ το τώρα — χωρίς λογαριασμό",
  "tryNowLine1": "Δοκίμασέ το τώρα",
  "tryNowLine2": "Χωρίς λογαριασμό",
  "badge": "Επίσκεψη ως guest",
  "sumScore": "Σκορ",
  "sumType": "Τύπος αγώνα",
  "saveTitle": "Ο πρώτος σου αγώνας είναι έτοιμος.",
  "saveSubtitle": "Μόλις κατέγραψες τον πρώτο σου αγώνα. Δημιούργησε δωρεάν λογαριασμό για να αποθηκευτεί μόνιμα και να ξεκινήσεις το τενιστικό σου ιστορικό.",
  "canTitle": "Το Tennis Log μπορεί ήδη να υπολογίσει",
  "beginningTitle": "Αυτή είναι μόνο η αρχή.",
  "beginningBody": "Συνέχισε και το Tennis Log θα μαθαίνει πολύ περισσότερα από κάθε αγώνα σου.",
  "google": "Συνέχεια με Google",
  "createAccount": "Δημιουργία λογαριασμού",
  "haveAccount": "Έχω ήδη λογαριασμό",
  "editAgain": "Επεξεργασία αγώνα",
  "whyLink": "Γιατί χρειάζομαι λογαριασμό;",
  "whyBody": "Οι αγώνες σου σου ανήκουν. Ένας λογαριασμός επιτρέπει στο Tennis Log να:",
  "whyB1": "αποθηκεύει το ιστορικό σου",
  "whyB2": "συγχρονίζει τις συσκευές σου",
  "whyB3": "χτίζει μακροπρόθεσμα στατιστικά",
  "whyB4": "δημιουργεί AI insights",
  "persisting": "Αποθήκευση του αγώνα σου…",
  "successTitle": "Τέλεια!",
  "successBody": "Ο πρώτος σου αγώνας είναι πλέον μέρος του τενιστικού σου ιστορικού.",
  "successContinue": "Πρόσθεσε περισσότερα στοιχεία αγώνα — προαιρετικά"
};

data.appWelcome = {
  "heading": "Καλώς ήρθες στο Tennis Log",
  "subheading": "Η αγωνιστική σου ιστορία ξεκινά με τον επόμενο αγώνα.",
  "googleCta": "Συνέχεια με Google",
  "googleHelper": "Γρήγορα, με ασφάλεια και χωρίς νέο κωδικό.",
  "guestCta": "Ξεκίνα χωρίς λογαριασμό",
  "guestHelper": "Κατάγραψε τώρα τον πρώτο σου αγώνα. Μπορείς να ασφαλίσεις τα δεδομένα σου με Google αργότερα.",
  "haveAccount": "Έχεις ήδη λογαριασμό; Σύνδεση",
  "carouselTitle": "Τι μπορούν να αποκαλύψουν 25 αγώνες;",
  "carouselSubtitle": "Όσο περισσότερους αγώνες καταγράφεις, τόσο πιο καθαρή γίνεται η εικόνα του παιχνιδιού σου.",
  "carouselTitle2": "Το Tennis Log σου μεγαλώνει με κάθε αγώνα",
  "carouselSubtitle2": "Κάνε swipe για να δεις τι μπορούν να γίνουν τα στατιστικά σου.",
  "card4": "Κάθε προπόνηση, θερμίδες και καρδιακοί παλμοί",
  "card5": "Οι αγώνες σου σε ημερολόγιο",
  "card1": "Η σεζόν σου με μια ματιά",
  "card2": "Δες πώς εξελίσσεται το παιχνίδι σου",
  "card3": "Ανακάλυψε μοτίβα που δεν φαίνονται εύκολα",
  "footer": "Δωρεάν βασικές λειτουργίες • Τα δεδομένα σου παραμένουν δικά σου • Φτιαγμένο για club players",
  "prev": "Προηγούμενο",
  "next": "Επόμενο",
  "mini": {
    "winRate": "Ποσοστό νικών",
    "matches": "Αγώνες",
    "sets": "Σετ που κέρδισες",
    "trend": "Εξέλιξη ποσοστού νικών",
    "you": "Εσύ",
    "opponent": "Αντίπαλος",
    "serve": "Σερβίς",
    "forehand": "Forehand",
    "backhand": "Backhand",
    "movement": "Μετακίνηση",
    "strength": "Δυνατό σημείο",
    "strengthBody": "Κερδίζεις το 78% των αγώνων όταν κάνεις εσύ το πρώτο break.",
    "opportunity": "Περιθώριο βελτίωσης",
    "opportunityBody": "Η αξιολόγηση του backhand πέφτει στα τρίτα σετ — θέμα φυσικής κατάστασης ή συγκέντρωσης."
  }
};

data.consent = { health: { title: "Δεδομένα υγείας — ρητή συγκατάθεση", body: "Οι καρδιακοί παλμοί, οι ζώνες παλμών, οι θερμίδες, η διάρκεια προπόνησης και τα στιγμιότυπα από smartwatch είναι δεδομένα υγείας. Το Tennis Log τα επεξεργάζεται μόνο αν το επιτρέψετε ρητά, συμπεριλαμβανομένης της αποστολής τους σε πάροχο AI για τα insights σας. Είναι προαιρετικό και μπορείτε να το ανακαλέσετε οποτεδήποτε από τις Ρυθμίσεις, οπότε και διαγράφονται τα αποθηκευμένα δεδομένα υγείας.", checkbox: "Συναινώ ρητά στην επεξεργασία των δεδομένων υγείας μου από το Tennis Log, όπως περιγράφεται.", enable: "Ενεργοποίηση δεδομένων υγείας", optional: "Προαιρετικό — το Tennis Log λειτουργεί πλήρως και χωρίς αυτά.", granted: "Τα δεδομένα υγείας ενεργοποιήθηκαν.", stale: "Το κείμενο συγκατάθεσης ενημερώθηκε. Ανανεώστε τη σελίδα και διαβάστε το ξανά.", error: "Δεν αποθηκεύτηκε η επιλογή σας. Δοκιμάστε ξανά.", } };

data.share = {
  button: "Κοινοποίηση αποτελέσματος",
  dialogTitle: "Κοινοποίηση αποτελέσματος",
  dialogSubtitle: "Δημιούργησε εικόνα του αγώνα για τα social media. Τίποτα δεν ανεβαίνει — η εικόνα δημιουργείται στη συσκευή σου.",
  showNames: "Εμφάνιση ονομάτων άλλων παικτών",
  showLocation: "Εμφάνιση τοποθεσίας",
  saveImage: "Αποθήκευση εικόνας",
  shareImage: "Κοινοποίηση",
  working: "Δημιουργία…",
  saved: "Η εικόνα αποθηκεύτηκε.",
  shared: "Κοινοποιήθηκε.",
  failed: "Δεν ήταν δυνατή η δημιουργία της εικόνας. Δοκίμασε ξανά.",
  shareUnsupported: "Αυτή η συσκευή δεν υποστηρίζει κοινοποίηση εικόνας — χρησιμοποίησε την Αποθήκευση εικόνας.",
  you: "Εσύ",
  yourTeam: "Η ομάδα σου",
  opponent: "Αντίπαλος",
  opposingTeam: "Αντίπαλη ομάδα",
  victory: "Νίκη",
  defeat: "Ήττα",
  draw: "Ισοπαλία",
  retired: "Εγκατάλειψη",
  incomplete: "Ημιτελής",
  retiredTag: "ΕΓΚ.",
};

export default data;
